import {
  faArrowCircleLeft,
  faBuilding,
  faCalendar,
  faCar,
  faCheckCircle,
  faCoins,
  faEnvelope,
  faEye,
  faFile,
  faHashtag,
  faHourglassEnd,
  faMobile,
  faMoneyBill,
  faMoneyBillWave,
  faTrashAlt,
  faUser,
  faUserCheck,
  faUsers,
  faUserTie,
  faPlane,
  faCreditCard,
  faArrowRight,
  faCopy,
  faSearch,
} from "@fortawesome/fontawesome-free-solid";
import {
  faArrowRightArrowLeft,
  faClockRotateLeft,
  faFileCircleCheck,
  faFileInvoice,
  faFileUpload,
  faGear,
  faLocationDot,
  faMessage,
  faPencil,
  faPlaneArrival,
  faSignsPost,
  faUsersRays,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LinearProgress from "@mui/material/LinearProgress";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import momenttz from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "../../components/b2b/Modal";
import SideBar from "../../components/b2b/SideBar";
import Header from "../../components/landingPage/Header";
import "aos/dist/aos.css";
import Select from "react-select";
import CountryList from "country-list-with-dial-code-and-flag";
import { IconButton, Skeleton, Tooltip } from "@mui/material";
import {
  getDateTimeDetailIST,
  setEditBookingDate,
  setEditBookingError,
  setFlightData,
} from "../../redux/app/booking/booking-slice";
import { clearTransactionRecordStoreStatus } from "../../redux/app/creditcard/creditcard-slice";
import axios from "axios";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { BriefcaseIcon, CreditCardIcon } from "@heroicons/react/solid";
import { Airlines, Luggage, Terminal } from "@mui/icons-material";
import { Send } from "@material-ui/icons";
import copy from "copy-to-clipboard";
import { setDateExistWithinEvent } from "../../redux/app/event/event-slice";
import alertCreditCard from "../../assets/credit_card.gif";
import { LoadingSpinner } from "../../components/loading/LoadingIcon";

let editItemCount = {};

const SingleBookingDetail = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [copyMsg, setcopyMsg] = useState(false);
  const { token, user } = useSelector((state) => state.auth);
  const [openCountryCode, setopenCountryCode] = useState(false);
  const {
    bookingDetailsById,
    uploadingInvoiceStatus,
    flightData,
    flightLoading,
    timeDetails,
    singleBookingDetailLoading,
    dateTimeIST,
    editBookingDate,
    multiCloneBookingLoading,
  } = useSelector((state) => state.booking);

  const { allCompany, companyDetails } = useSelector((state) => state.company);
  const { bookingCredicards } = useSelector((state) => state.creditcard);
  const [companyName, setCompanyName] = useState();
  const [clonedBookingDetail, setclonedBookingDetail] = useState({});
  const [multiClonedBookingDetail, setMultiClonedBookingDetail] = useState({});
  const [searchCountry, setSearchCountry] = useState("");
  const [iscountryListOpen, setiscountryListOpen] = useState(false);
  const [isBookingClone, setisBookingClone] = useState(false);
  const [cloneType, setCloneType] = useState("single");
  const [groupOption, setGroupOption] = useState("");
  const [affiliatePaymentModalOpen, setaffiliatePaymentModalOpen] =
    useState(false);
  const [affiliatepaymentStatus, setaffiliatepaymentStatus] = useState();
  // const [isBookingStatusbox, setisBookingStatusbox] = useState(false);
  const [isBookingCompleteStatus, setisBookingCompleteStatus] = useState(false);
  const [isBookingNoShowStatus, setisBookingNoShowStatus] = useState(false);
  const [bookingActionModal, setbookingActionModal] = useState({
    cancel: false,
    paid: false,
    refund: false,
    documents: false,
    sms: false,
    edit: false,
    affiliate: false,
    driver: false,
    invoice: false,
    uploadInvoice: false,
  });

  const [affiliateVoucherSend, setaffiliateVoucherSend] = useState(false);

  const [durationForAffiliate, setdurationForAffiliate] = useState();

  const [openPob, setopenPob] = useState(false);

  console.log(user, "user details");

  useEffect(() => {
    const timer = setTimeout(() => {
      if (localStorage.getItem("affiliateVoucherSend")) {
        const paxbody = JSON.parse(localStorage.getItem("paxbody"));
        const travelDateBody = traveldateUpdate
          ? traveldateUpdate
          : bookingDetailsById?.travelDate;
        const travelTimeBody = travelTimeUpdate
          ? travelTimeUpdate
          : bookingDetailsById?.travelTime;
        dispatch({
          type: "SEND_AFFILIATE_VOUCHER",
          payload: {
            token,
            body: {
              affiliate_name: `${bookingDetailsById?.affiliateDetails?.affiliateName}/Ammendment`,
              company_name: companyName,
              email: bookingDetailsById?.affiliateDetails?.email1,
              email2: bookingDetailsById?.affiliateDetails?.email2
                ? bookingDetailsById?.affiliateDetails?.email2
                : "",
              booking_id: bookingDetailsById?.bookingId,
              from: bookingDetailsById?.source?.placename,
              to: bookingDetailsById?.destination?.placename,
              timeAndDate:
                moment(travelDateBody).format("DD-MM-YYYY") +
                " | " +
                travelTimeBody,
              bookingType:
                bookingDetailsById?.bookingType?.charAt(0)?.toUpperCase() +
                bookingDetailsById?.bookingType?.slice(1).toLowerCase(),
              bookingStatus: bookingDetailsById?.bookingStatus,
              distance:
                bookingDetailsById?.bookingType === "HOURLY"
                  ? `${
                      bookingDetailsById?.durationForAffiliate
                        ? bookingDetailsById?.durationForAffiliate
                        : bookingDetailsById?.duration + " hours"
                    }`
                  : Math.round(bookingDetailsById?.travelDistance) + " KM",
              flt_no: paxbody?.flightNumber,
              sp_req: bookingDetailsById?.passengerDetails?.specialRequest,
              vehicleType: bookingDetailsById?.vehicleDetails?.categoryType,
              price:
                bookingDetailsById?.purchaseCurrency +
                " " +
                bookingDetailsById?.purchasePrice,
              passengerName: paxbody?.firstName + " " + paxbody?.lastName,
              pax_email: bookingDetailsById?.passengerDetails?.email,
              mob_number: paxbody?.code + " " + paxbody?.phone,
              pax: bookingDetailsById?.passenger,
              emergency_number:
                settings?.emergencyContact1 +
                " " +
                settings?.emergencyContact2 +
                " " +
                settings?.emergencyContact3,
            },
          },
        });
        localStorage.removeItem("affiliateVoucherSend");
        localStorage.removeItem("paxbody");
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [localStorage.getItem("affiliateVoucherSend")]);

  const downloadBooking = () => {
    const input = document.createElement("invoice");
    html2canvas(input, {
      // scrollX: -window.scrollX,
      width: 1000,
      height: 3000,
      windowHeight: 500,
      windowWidth: 800,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", "a4");
      pdf.addImage(imgData, "JPEG", 10, 50);
      pdf.save("invoice.pdf");
    });
  };

  const affiliatePaymentStatus = () => {
    dispatch({
      type: "AFFILIATE_PAYMENT_STATUS",
      payload: {
        token: token,
        body: {
          bookingId: bookingDetailsById?.bookingId,
          paymentType: affiliatepaymentStatus,
        },
      },
    });
    dispatch({
      type: "BOOKING_HISTORY_CREATE",
      payload: {
        body: {
          booking: bookingDetailsById?._id,
          userName: user?.userName,
          updateItem: "Affiliate Payment Status",
          prevValue: "Pending",
          currentValue: affiliatepaymentStatus,
        },
        token,
        bookingId: bookingDetailsById?._id,
      },
    });
  };

  let travelTimeInSeconds =
    new Date(bookingDetailsById?.travelTimeStamp).getTime() / 1000;
  let currentTimeInSeconds = new Date(timeDetails.date_time).getTime() / 1000;
  let timeDiffInSeconds = Math.abs(travelTimeInSeconds - currentTimeInSeconds);

  const [timeZone, settimeZone] = useState();

  const getTimeZone = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/places/placeTimezone?lat=${bookingDetailsById?.source?.lat}&lng=${bookingDetailsById?.source?.lng}`
    );
    settimeZone(response?.data?.timezone);
  };

  useEffect(() => {
    if (bookingDetailsById?.source?.lat && bookingDetailsById?.source?.lng) {
      getTimeZone();
    }
  }, [bookingDetailsById?.source?.lat, bookingDetailsById?.source?.lng]);

  useEffect(() => {
    dispatch(
      setFlightData({
        flightData: {},
      })
    );
  }, []);

  useEffect(() => {
    dispatch({ type: "GET_BOOKING_DETAILS_BY_ID", payload: { id: id } });
    dispatch({
      type: "GET_ALL_ACTIVE_AFFILIATES",
      payload: { token },
    });
  }, [dispatch, id, token]);

  useEffect(() => {
    dispatch({
      type: "GET_ALL_COMPANY",
      payload: { token },
    });
  }, []);

  // useEffect(() => {
  //   if (timeZone) {
  //
  //     dispatch({
  //       type: "GET_DATE_TIME_DETAILS_IST",
  //       payload: {
  //         travellDateTime:`${moment(bookingDetailsById?.travelDate).format(
  //           "YYYY-MM-DD"
  //         )} ${bookingDetailsById?.travelTime}`,
  //         IndianTimezone: "Asia/Kolkata",
  //         travellTimeZone: timeZone,
  //       },
  //     });

  //   }
  //   // else {
  //   //   dispatch({
  //   //     type: "GET_TIME_DETAILS",
  //   //     payload: {
  //   //       lat: bookingDetailsById?.source?.lat,
  //   //       lng: bookingDetailsById?.source?.lng,
  //   //       travellDateTime: moment(bookingDetailsById?.travelDate).format(
  //   //         "YYYY-MM-DD HH:mm "
  //   //       ),
  //   //       IndianTimezone: "Asia/Kolkata",
  //   //     },
  //   //   });
  //   // }
  // }, [bookingDetailsById, timeZone]);

  let companyNameDetail = allCompany?.forEach((company) => {
    company?.users?.forEach((user) => {
      if (user?.userName === bookingDetailsById?.userName) {
        return company?.companyName;
      }
    });
  });

  let ZoneCurrentTime = new Date(
    momenttz().tz("Europe/London").format("YYYY-MM-DD HH:mm:ss")
  );
  let travel_Time = new Date(bookingDetailsById?.travelTimeStamp);

  var res = Math.abs(ZoneCurrentTime - travel_Time) / 1000;
  var days = Math.floor(res / 86400);
  var hours = Math.floor(res / 3600) % 24;
  var minutes = Math.floor(res / 60) % 60;
  var seconds = res % 60;

  const [userCompany, setUserCompany] = useState();
  const [cancelFee, setcancelFee] = useState(undefined);
  const [priceUpdateInputState, setpriceUpdateInputState] = useState();
  const [currencyUpdate, setcurrencyUpdate] = useState();
  const [extraPay, setextraPay] = useState();
  const [extraHour, setextraHour] = useState();
  const [traveldateUpdate, settraveldateUpdate] = useState();
  const [travelTimeUpdate, settravelTimeUpdate] = useState();
  const { settings } = useSelector((state) => state.settings);
  // const [editItemCount, seteditItemCount] = useState({
  //   amount: false,
  //   travelDate: false,
  //   travelTime: false,
  //   phone: false,
  //   firstName: false,
  //   lastName: false,
  //   flightNumber: false,
  // });

  //
  //

  useEffect(() => {
    settraveldateUpdate(editBookingDate);
  }, [editBookingDate]);

  console.log(currencyUpdate, "<<---- edit currency ");

  const [editTravelTimeStamp, seteditTravelTimeStamp] = useState();

  useEffect(() => {
    if (clonedBookingDetail?.travelDate && clonedBookingDetail?.travelTime) {
      let travelDatec = moment(clonedBookingDetail?.travelDate).format(
        "YYYY-MM-DD"
      );

      let travelTimec = clonedBookingDetail.travelTime;

      const dateTime = momenttz.tz(`${travelDatec} ${travelTimec}`, timeZone);

      const formattedTimestamp = dateTime.format();

      setclonedBookingDetail({
        ...clonedBookingDetail,
        travelTimeStamp: formattedTimestamp,
        timeZone: timeZone,
      });
    }
  }, [clonedBookingDetail?.travelDate, clonedBookingDetail?.travelTime]);

  useEffect(() => {
    if (traveldateUpdate && travelTimeUpdate) {
      let travelDatec = moment(traveldateUpdate).format("YYYY-MM-DD");

      let travelTimec = travelTimeUpdate;

      const dateTime = momenttz.tz(`${travelDatec} ${travelTimec}`, timeZone);

      const formattedTimestamp = dateTime.format();

      seteditTravelTimeStamp(formattedTimestamp);

      dispatch({
        type: "GET_DATE_TIME_DETAILS_IST",
        payload: {
          travellDateTime: `${moment(traveldateUpdate).format(
            "YYYY-MM-DD"
          )} ${travelTimeUpdate}`,
          IndianTimezone: "Asia/Kolkata",
          travellTimeZone: timeZone,
        },
      });
    }
  }, [traveldateUpdate, travelTimeUpdate]);

  const [dateChange, setDateChange] = useState();
  const [openHistory, setopenHistory] = useState(false);

  const [openSummaryNav, setopenSummaryNav] = useState(false);

  const [timeChange, setTimeChange] = useState("10:00");
  const [tzUpdate, setTzUpdate] = useState();
  const [isaffiliateNoteEdit, setisaffiliateNoteEdit] = useState(false);

  const [paymentMethod, setpaymentMethod] = useState();
  const paymentNoteInputRef = useRef();

  const [invoiceVisible, setinvoiceVisible] = useState(false);
  const [isBookingEditable, setIsBookingEditable] = useState(false);
  const [invoiceMailToBeSend, setinvoiceMailToBeSend] = useState();
  // for affiliate
  const [assignAffiliateDetail, setassignAffiliateDetail] = useState({
    affiliateContact: "",
    affiliateEmail: "",
    affiliateId: "",
    affiliateNote: "",
    purchasePrice: "",
    purchaseCurrency: "",
    affiliateName: "",
  });

  // for driver
  const [assignDriverDetail, setassignDriverDetail] = useState({
    driverContact: "",
    driverName: "",
    affiliateId: "",
  });

  // for invoice
  const [invoiceData, setInvoiceData] = useState();
  const [document, setDocument] = useState({
    isInvoice: false,
    isVoucher: false,
    isDriver: false,
  });

  // const [invoice, setinvoice] = useState(initialState);
  let time = dateChange + " " + timeChange;

  useEffect(() => {
    let t = moment(time).format("YYYY-MM-DD HH:mm ");
    setTzUpdate(t);
  }, [time]);

  useEffect(() => {
    allCompany?.map((company) => {
      return company?.users?.map((companyuser) => {
        return (
          companyuser?.userName === user?.userName && setUserCompany(company)
        );
      });
    });
  }, [user, allCompany]);

  const [isCancelCheck, setIsCancelCheck] = useState();

  useEffect(() => {
    editItemCount = {};
    bookingDetailsById?.history?.forEach((history) => {
      editItemCount[history?.updateItem] = true;
    });
  }, [bookingDetailsById?.history]);

  const cancelBooking = async () => {
    if (isCancelCheck) {
      toast.loading("Cancelling Booking...");
      const body = {
        bookingId: id,
        cancellationFee: cancelFee
          ? cancelFee
          : days === 0 && hours < 24
          ? bookingDetailsById?.priceDetails?.amount
          : 0,
        bookingStatus: "CANCELLED",
      };

      // let resamount = await axios.get(
      //   `${process.env.REACT_APP_BASE_URL}/bookings/currencyLayer?from=${
      //     bookingDetailsById?.priceDetails.currency
      //   }&to=USD&amount=${Math.round(bookingDetailsById?.priceDetails.amount)}`,
      //   {
      //     withCredentials: true,
      //   }
      // );

      //

      let cnclfee = cancelFee
        ? cancelFee
        : days === 0 && hours < 24
        ? bookingDetailsById?.priceDetails?.amount
        : 0;

      let totalUnpaidBooking =
        bookingDetailsById?.user?.unpaidBooking -
        bookingDetailsById?.bookingPriceInUsd +
        parseInt(cnclfee);

      let totalUnpaidBookingCompany =
        parseFloat(bookingDetailsById?.user?.company?.totalUnpaidBooking) -
        bookingDetailsById?.bookingPriceInUsd +
        parseInt(cnclfee);

      let availableLimitCompany =
        bookingDetailsById?.user?.company?.availableLimit +
        bookingDetailsById?.bookingPriceInUsd -
        parseInt(cnclfee);

      let affiliateVoucherData;

      if (bookingDetailsById?.affiliateDetails?.affiliateName) {
        affiliateVoucherData = {
          company_name: companyName,
          bookingId: bookingDetailsById?.bookingId,
          timeAndDate:
            moment(bookingDetailsById?.travelDate).format("DD-MM-YYYY") +
            " | " +
            bookingDetailsById?.travelTime,
          affiliate_name: bookingDetailsById?.affiliateDetails?.affiliateName,
          from: bookingDetailsById?.source?.placename,
          to: bookingDetailsById?.destination?.placename,
          bookingType:
            bookingDetailsById?.bookingType?.charAt(0)?.toUpperCase() +
            bookingDetailsById?.bookingType?.slice(1).toLowerCase(),
          bookingStatus: bookingDetailsById?.bookingStatus,
          distance:
            bookingDetailsById?.bookingType === "HOURLY"
              ? `${bookingDetailsById?.duration + " hours"}`
              : Math.round(bookingDetailsById?.travelDistance) + " KM",
          flt_no: bookingDetailsById?.passengerDetails?.flightNumber,
          special_request: bookingDetailsById?.passengerDetails?.specialRequest,
          vehicleType: bookingDetailsById?.vehicleDetails?.categoryType,
          cancellation_price:
            bookingDetailsById?.purchaseCurrency + " " + cancelFee
              ? cancelFee
              : days === 0 && hours < 24
              ? bookingDetailsById?.priceDetails?.amount
              : 0,
          passengerName:
            bookingDetailsById?.passengerDetails?.firstName +
            " " +
            bookingDetailsById?.passengerDetails?.lastName,
          mob_number:
            bookingDetailsById?.passengerDetails?.code +
            " " +
            bookingDetailsById?.passengerDetails?.phone,
          paxCount: bookingDetailsById?.passenger,
          emergency_number:
            settings?.emergencyContact1 +
            " " +
            settings?.emergencyContact2 +
            " " +
            settings?.emergencyContact3,
        };
      }

      dispatch({
        type: "UPDATE_BOOKING",
        payload: {
          body,
          token,
          affiliate: bookingDetailsById?.affiliateDetails?.affiliateName,
          bookingDetails: bookingDetailsById,
          affiliateVoucherData: affiliateVoucherData,
          msg: "Booking Cancelled Successfully",
        },
      });
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "bookingStatus",
            prevValue: bookingDetailsById?.bookingStatus,
            currentValue: "CANCELLED",
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
      if (!bookingDetailsById?.userName?.includes("Offline")) {
        dispatch({
          type: "EDIT_USER_FOR_CANCEL_BOOKING",
          payload: {
            userId: bookingDetailsById?.user?._id,
            body: {
              unpaidBooking: totalUnpaidBooking,
            },
            token,
          },
        });
        dispatch({
          type: "EDIT_COMPANY_FOR_CANCEL_BOOKING",
          payload: {
            companyId: bookingDetailsById?.user?.company?._id,
            body: {
              totalUnpaidBooking: totalUnpaidBookingCompany,
              availableLimit: availableLimitCompany,
            },
            token,
          },
        });
      }
      setbookingActionModal({ cancel: false });
    } else {
      toast.warn("Please check the checkbox to agree cancellation policy");
    }
  };

  const paidHandler = async () => {
    const body = {
      bookingId: id,
      paymentType: paymentMethod,
      receivable_note: paymentNoteInputRef.current.value,
      paymentStatus: "PAID",
    };

    // let resamount = await axios.get(
    //   `${process.env.REACT_APP_BASE_URL}/bookings/currencyLayer?from=${
    //     bookingDetailsById?.priceDetails.currency
    //   }&to=USD&amount=${Math.round(bookingDetailsById?.priceDetails.amount)}`,
    //   {
    //     withCredentials: true,
    //   }
    // );

    let totalUnpaidBooking =
      bookingDetailsById?.user?.unpaidBooking -
      bookingDetailsById?.bookingPriceInUsd;

    let totalUnpaidBookingCompany =
      bookingDetailsById?.user?.company?.totalUnpaidBooking -
      bookingDetailsById?.bookingPriceInUsd;

    let availableLimitCompany =
      bookingDetailsById?.user?.company?.availableLimit +
      bookingDetailsById?.bookingPriceInUsd;

    dispatch({
      type: "UPDATE_BOOKING",
      payload: { body, token, msg: "Booking Paid Successfully" },
    });
    dispatch({
      type: "BOOKING_HISTORY_CREATE",
      payload: {
        body: {
          booking: bookingDetailsById?._id,
          userName: user?.userName,
          updateItem: "Payment Status",
          prevValue: bookingDetailsById?.paymentStatus,
          currentValue: "PAID",
        },
        token,
        bookingId: bookingDetailsById?._id,
      },
    });
    if (!bookingDetailsById?.userName?.includes("Offline")) {
      dispatch({
        type: "EDIT_USER",
        payload: {
          userId: bookingDetailsById?.user._id,
          body: {
            unpaidBooking: totalUnpaidBooking,
          },
          token,
        },
      });
      dispatch({
        type: "EDIT_COMPANY",
        payload: {
          companyId: bookingDetailsById?.user?.company?._id,
          body: {
            totalUnpaidBooking: totalUnpaidBookingCompany,
            availableLimit: availableLimitCompany,
          },
          token,
        },
      });
    }
    setbookingActionModal({ paid: false });
  };

  const [passengerUpdate, setpassengerUpdate] = useState({
    firstName: "",
    lastName: "",
    flightNumber: "",
    phone: "",
    referenceNumber: "",
  });

  const editBooking = async () => {
    dispatch(
      setEditBookingError({
        editBookingError: "",
      })
    );
    dispatch(
      setDateExistWithinEvent({
        DateExistsWithinEvent: "",
      })
    );

    if (priceUpdateInputState !== bookingDetailsById?.priceDetails?.amount) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "amount",
            prevValue: bookingDetailsById?.priceDetails?.amount,
            currentValue: priceUpdateInputState,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (currencyUpdate !== bookingDetailsById?.priceDetails?.currency) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "currency",
            prevValue: bookingDetailsById?.priceDetails?.currency,
            currentValue: currencyUpdate,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (extraPay !== bookingDetailsById?.extraPay) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "extraPay",
            prevValue: bookingDetailsById?.extraPay,
            currentValue: extraPay,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (extraHour !== bookingDetailsById?.extraHour) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "extraHour",
            prevValue: bookingDetailsById?.extraHour,
            currentValue: extraHour,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (
      passengerUpdate.firstName !==
      bookingDetailsById?.passengerDetails?.firstName
    ) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "firstName",
            prevValue: bookingDetailsById?.passengerDetails?.firstName,
            currentValue: passengerUpdate.firstName,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (
      passengerUpdate.lastName !==
      bookingDetailsById?.passengerDetails?.lastName
    ) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "lastName",
            prevValue: bookingDetailsById?.passengerDetails?.lastName,
            currentValue: passengerUpdate.lastName,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (
      passengerUpdate.flightNumber !==
      bookingDetailsById?.passengerDetails?.flightNumber
    ) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "flightNumber",
            prevValue: bookingDetailsById?.passengerDetails?.flightNumber,
            currentValue: passengerUpdate.flightNumber,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (passengerUpdate.phone !== bookingDetailsById?.passengerDetails?.phone) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "phone",
            prevValue: bookingDetailsById?.passengerDetails?.phone,
            currentValue: passengerUpdate.phone,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (
      moment(traveldateUpdate).format("YYYY-MM-DD") !==
      moment(bookingDetailsById?.travelDate).format("YYYY-MM-DD")
    ) {
      localStorage.setItem("affiliateVoucherSend", true);
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "travelDate",
            prevValue: bookingDetailsById?.travelDate,
            currentValue: traveldateUpdate,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (travelTimeUpdate !== bookingDetailsById?.travelTime) {
      localStorage.setItem("affiliateVoucherSend", true);
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "travelTime",
            prevValue: bookingDetailsById?.travelTime,
            currentValue: travelTimeUpdate,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
      localStorage.setItem("affiliateVoucherSend", true);
    }

    // let resamount = await axios.get(
    //   `${process.env.REACT_APP_BASE_URL}/bookings/currencyLayer?from=${
    //     bookingDetailsById?.priceDetails.currency
    //   }&to=USD&amount=${Math.round(bookingDetailsById?.priceDetails.amount)}`,
    //   {
    //     withCredentials: true,
    //   }
    // );

    let newEditedAmount = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/currencyLayer?from=${
        bookingDetailsById?.priceDetails.currency
      }&to=USD&amount=${Math.round(parseInt(priceUpdateInputState))}`,
      {
        withCredentials: true,
      }
    );

    if (
      newEditedAmount?.data?.result !== undefined ||
      newEditedAmount?.data?.result !== null
    ) {
      let totalUnpaidBooking =
        user?.unpaidBooking -
        bookingDetailsById?.bookingPriceInUsd +
        newEditedAmount?.data?.result;

      let totalUnpaidBookingCompany =
        user?.company?.totalUnpaidBooking -
        bookingDetailsById?.bookingPriceInUsd +
        newEditedAmount?.data?.result;

      let availableLimitCompany =
        user?.company?.availableLimit +
        bookingDetailsById?.bookingPriceInUsd -
        newEditedAmount?.data?.result;

      const body = {
        bookingId: id,
        priceDetails: {
          amount: parseFloat(priceUpdateInputState),
          currency: currencyUpdate,
        },
        extraPay: extraPay,
        extraHour: extraHour,
        totalPayment: parseInt(priceUpdateInputState) + parseInt(extraPay || 0),
        travelDate: traveldateUpdate,
        travelTime: travelTimeUpdate,
        durationForAffiliate: durationForAffiliate,
        travelTimeStamp: editTravelTimeStamp,
        indianTravelDate: moment(dateTimeIST?.converted_time).format(),
        indianTravelTime: moment(dateTimeIST?.converted_time).format("HH:mm"),
      };

      if (
        passengerUpdate.firstName ||
        passengerUpdate.lastName ||
        passengerUpdate.flightNumber ||
        passengerUpdate.phone
      ) {
        const passengerBody = {
          firstName: passengerUpdate.firstName
            ? passengerUpdate.firstName
            : bookingDetailsById?.passengerDetails?.firstName,
          lastName: passengerUpdate.lastName
            ? passengerUpdate.lastName
            : bookingDetailsById?.passengerDetails?.lastName,
          flightNumber: passengerUpdate.flightNumber
            ? passengerUpdate.flightNumber
            : bookingDetailsById?.passengerDetails?.flightNumber,
          phone: passengerUpdate.phone
            ? passengerUpdate.phone
            : bookingDetailsById?.passengerDetails?.phone,
          country: passengerUpdate.country
            ? passengerUpdate.country
            : bookingDetailsById?.passengerDetails?.country,
          code: passengerUpdate.code
            ? passengerUpdate.code
            : bookingDetailsById?.passengerDetails?.code,
          referenceNumber: passengerUpdate.referenceNumber
            ? passengerUpdate.referenceNumber
            : bookingDetailsById?.passengerDetails?.referenceNumber,
        };

        dispatch({
          type: "PASSENGER_DETAIL_UPDATE",
          payload: {
            body: passengerBody,
            token,
            passengerId: bookingDetailsById?.passengerDetails?._id,
          },
        });
        localStorage.setItem("affiliateVoucherSend", true);
        localStorage.setItem("paxbody", JSON.stringify(passengerBody));
      }

      if (!bookingDetailsById?.userName?.includes("Offline")) {
        dispatch({
          type: "EDIT_USER",
          payload: {
            userId: bookingDetailsById?.user?._id,
            body: {
              unpaidBooking: totalUnpaidBooking,
            },
            token,
          },
        });
        dispatch({
          type: "EDIT_COMPANY",
          payload: {
            companyId: bookingDetailsById?.user?.company?._id,
            body: {
              totalUnpaidBooking: totalUnpaidBookingCompany,
              availableLimit: availableLimitCompany,
            },
            token,
          },
        });
      }
      localStorage.setItem("affiliateVoucherSend", true);

      dispatch({
        type: "UPDATE_BOOKING",
        payload: { body, token },
      });

      dispatch(getDateTimeDetailIST({ dateTimeIST: {} }));
    } else {
      toast.error("Can't process your request, please try again later.");
    }
    setbookingActionModal({ edit: false });
  };

  const afiliateAssignedDate = moment().format("YYYY-MM-DD HH:mm:ss");
  const isoDateAfiliate = new Date(afiliateAssignedDate).toISOString();

  const assignAffiliateHandler = () => {
    const body = {
      bookingId: id,
      affiliateDetails: assignAffiliateDetail.affiliateId
        ? assignAffiliateDetail.affiliateId
        : bookingDetailsById?.affiliateDetails?._id,
      affiliateNote: assignAffiliateDetail.affiliateNote
        ? assignAffiliateDetail.affiliateNote
        : bookingDetailsById?.affiliateNote,
      afiliateAssignedAt: isoDateAfiliate,
      afiliateAssignedBy: user.userName,
      purchasePrice: assignAffiliateDetail.purchasePrice,
      purchaseCurrency: assignAffiliateDetail.purchaseCurrency,
      creditCards: bookingCredicards.length > 0 ? bookingCredicards : [],
    };

    dispatch({
      type: "UPDATE_BOOKING",
      payload: { body, token, msg: "Affiliate Assigned Successfully" },
    });

    if (
      bookingDetailsById?.purchasePrice !== assignAffiliateDetail.purchasePrice
    ) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "purchasePrice",
            prevValue: bookingDetailsById?.purchasePrice,
            currentValue: assignAffiliateDetail.purchasePrice,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    if (
      bookingDetailsById?.purchaseCurrency !==
      assignAffiliateDetail.purchaseCurrency
    ) {
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "purchaseCurrency",
            prevValue: bookingDetailsById?.purchaseCurrency,
            currentValue: assignAffiliateDetail.purchaseCurrency,
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }

    //

    const docketBody = {
      bookingId: bookingDetailsById?.bookingId,
      travelDate: bookingDetailsById?.travelDate,
      bookingType: bookingDetailsById?.bookingType,
      tripNotes: `
        Pickup: ${bookingDetailsById?.source?.placename} 
        Dropoff: ${bookingDetailsById?.destination?.placename}
        Booking Type: ${
          bookingDetailsById?.bookingType?.charAt(0)?.toUpperCase() +
          bookingDetailsById?.bookingType?.slice(1).toLowerCase()
        }
        Passenger Name: ${
          bookingDetailsById?.passengerDetails?.firstName +
          " " +
          bookingDetailsById?.passengerDetails?.lastName
        }
      `,
      sellingPriceCurrency: bookingDetailsById?.priceDetails?.currency,
      sellingPrice: bookingDetailsById?.priceDetails?.amount,
      // sellingPriceRemarks: "This is selling remarks",
      purchasePriceCurrency: assignAffiliateDetail.purchaseCurrency,
      purchasePrice: assignAffiliateDetail.purchasePrice,
      purchasePriceRemarks: assignAffiliateDetail.affiliateNote,

      passengerName:
        bookingDetailsById?.passengerDetails?.firstName +
        " " +
        bookingDetailsById?.passengerDetails?.lastName,
      status: "OK",
    };

    dispatch({
      type: "CREATE_DOCKET",
      payload: docketBody,
    });

    dispatch(clearTransactionRecordStoreStatus());
    setbookingActionModal({ affiliate: false });
  };

  const driverAssignHandler = () => {
    const body = {
      bookingId: id,
      driver: true,
      driverName: assignDriverDetail.driverName,
      driverContactNumber: assignDriverDetail.driverContact,
      // affiliateid: assignDriverDetail.affiliateId,
    };
    dispatch({
      type: "UPDATE_BOOKING",
      payload: { body, token, msg: "Driver Assigned Successfully" },
    });
    setbookingActionModal({ affiliate: false });
  };

  const invoiceForm = new FormData();

  const uploadInvoiceHandler = () => {
    invoiceForm.append("bookingId", id);
    invoiceForm.append("invoice_code_num", invoiceData);

    dispatch({
      type: "UPDATE_BOOKING",
      payload: {
        body: invoiceForm,
        token,
        bookingId: id,
        msg: "Invoice Uploaded Successfully",
      },
    });
    setbookingActionModal({ uploadInvoice: false });
  };

  const showFlightStatus = () => {
    if (bookingDetailsById?.passengerDetails?.flightNumber) {
      dispatch({
        type: "GET_FLIGHT_DATA",
        payload: {
          flightNumberIata: bookingDetailsById?.passengerDetails?.flightNumber,
          year: moment(bookingDetailsById?.travelDate).format("YYYY"),
          month: moment(bookingDetailsById?.travelDate).format("MM"),
          date: moment(bookingDetailsById?.travelDate).format("DD"),
        },
      });
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "Flight status check",
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }
  };

  useEffect(() => {
    allCompany?.map((company) => {
      return company?.users?.map((cuser) => {
        return user?.role === "ADMIN"
          ? setCompanyName(user?.companyName)
          : cuser?.userName === bookingDetailsById?.userName &&
              setCompanyName(company?.companyName);
      });
    });
  }, [allCompany, bookingDetailsById?.userName, user?.role, user?.companyName]);

  const sendDocuments = () => {
    if (document.isInvoice) {
      dispatch({
        type: "SEND_INVOICE",
        payload: {
          token,
          body: {
            email: invoiceMailToBeSend,
            company_name: user?.company?.companyName,
            invoice_number: bookingDetailsById?.invoice_code_num,
            booking_id: bookingDetailsById?.bookingId,
            from: bookingDetailsById?.source?.placename,
            to: bookingDetailsById?.destination?.placename,
            booking_price_unit: bookingDetailsById?.priceDetails?.currency,
            booking_price_currency: Math.round(
              bookingDetailsById?.priceDetails?.amount
            ),
          },
        },
      });

      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "Invoice Sent",
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }
    if (document.isVoucher) {
      let travelDt = bookingDetailsById?.travelDate?.split("T")[0];
      dispatch({
        type: "SEND_VOUCHER",
        payload: {
          token,
          body: {
            company_name: user?.company?.companyName,
            email: invoiceMailToBeSend,
            booking_id: bookingDetailsById?.bookingId,
            from: bookingDetailsById?.source?.placename,
            to: bookingDetailsById?.destination?.placename,
            timeAndDate:
              moment(travelDt).format("Do MMM YYYY") +
              " | " +
              bookingDetailsById?.travelTime,
            bookingType:
              bookingDetailsById?.bookingType?.charAt(0)?.toUpperCase() +
              bookingDetailsById?.bookingType?.slice(1).toLowerCase(),
            bookingStatus: bookingDetailsById?.bookingStatus,
            distance:
              bookingDetailsById?.bookingType === "HOURLY"
                ? `${bookingDetailsById?.duration + " hrs"}`
                : Math.round(bookingDetailsById?.travelDistance) + " KM",
            flt_no: bookingDetailsById?.passengerDetails?.flightNumber,
            sp_req: bookingDetailsById?.passengerDetails?.specialRequest,
            vehicleType: bookingDetailsById?.vehicleDetails?.categoryType,
            passengerName:
              bookingDetailsById?.passengerDetails?.firstName +
              " " +
              bookingDetailsById?.passengerDetails?.lastName,
            pax_email: bookingDetailsById?.passengerDetails?.email,
            mob_number:
              bookingDetailsById?.passengerDetails?.code +
              " " +
              bookingDetailsById?.passengerDetails?.phone,
            pax: bookingDetailsById?.passenger,
            emergency_number:
              settings?.emergencyContact1 +
              " " +
              settings?.emergencyContact2 +
              " " +
              settings?.emergencyContact3,
          },
        },
      });
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "Voucher Sent",
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }
    if (document.isDriver) {
      dispatch({
        type: "SEND_DRIVER_DETAIL",
        payload: {
          token,
          body: {
            email: invoiceMailToBeSend,
            bookingId: bookingDetailsById?.bookingId,
            from: bookingDetailsById?.source?.placename,
            to: bookingDetailsById?.destination?.placename,
            timeAndDate:
              moment(bookingDetailsById?.travelDate).format("DD-MM-YYYY") +
              " | " +
              bookingDetailsById?.travelTime,
            bookingType:
              bookingDetailsById?.bookingType?.charAt(0)?.toUpperCase() +
              bookingDetailsById?.bookingType?.slice(1).toLowerCase(),
            driverName: bookingDetailsById?.driverDetails?.name,
            driverMobile: bookingDetailsById?.driverDetails?.contactNumber,
            // emergency_number:
          },
        },
      });
      dispatch({
        type: "BOOKING_HISTORY_CREATE",
        payload: {
          body: {
            booking: bookingDetailsById?._id,
            userName: user?.userName,
            updateItem: "Driver Details Sent",
          },
          token,
          bookingId: bookingDetailsById?._id,
        },
      });
    }
  };

  console.log(passengerUpdate, "passengerUpdate");

  let embedLink = bookingDetailsById?.trackingDetails?.views?.embed_url;

  const generateGroupId = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bookings/generateGroupBookingId`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      console.log("generateGroupId", response.data);

      setMultiClonedBookingDetail({
        ...multiClonedBookingDetail,
        groupName: response.data?.data,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setMultiClonedBookingDetail({
      ...multiClonedBookingDetail,
      groupName: "",
    });
  }, [groupOption]);

  const today = new Date();
  const minDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  return (
    <>
      {/* invoice */}

      <div className="h-screen w-screen fixed">
        <Header token={token} />
        <div className="flex">
          <SideBar />

          <div className="w-screen h-[90vh] overflow-y-auto scrollbar">
            {bookingActionModal.cancel && (
              <>
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>
                <Modal
                  addOnClick={() => {
                    cancelBooking();
                  }}
                  addButtonLabel="Cancel Booking"
                  cancelOnClick={() => setbookingActionModal({ cancel: false })}
                  heading={`Cancel Booking for ${bookingDetailsById?.bookingId}`}
                  isSinglebooingDetailCanecl={true}
                  cancelFeeCheckbox={(e) => {
                    setIsCancelCheck(e.target.checked);
                  }}
                  cancelFeeInput={(e) => {
                    setcancelFee(e.target.value);
                  }}
                  canelFeeInputValue={
                    cancelFee !== undefined
                      ? cancelFee
                      : days === 0 && hours < 24
                      ? Math.round(bookingDetailsById?.priceDetails?.amount)
                      : 0
                  }
                  travelDate={bookingDetailsById?.travelDate}
                  travelTime={bookingDetailsById?.travelTime}
                />
              </>
            )}
            {bookingActionModal.edit && (
              <>
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>
                <Modal
                  cancelOnClick={() => {
                    dispatch(
                      setEditBookingError({
                        editBookingError: "",
                      })
                    );
                    dispatch(
                      setDateExistWithinEvent({
                        DateExistsWithinEvent: "",
                      })
                    );
                    setbookingActionModal({ edit: false });
                    dispatch(
                      setEditBookingDate({
                        editBookingDate: "",
                      })
                    );
                  }}
                  heading="Edit Booking"
                  addButtonLabel={"Save"}
                  addOnClick={editBooking}
                  isBookingEditable={isBookingEditable}
                  setEditBookingTimeZone={timeZone}
                  isSinglebooingDetailEdit={true}
                  priceUpdateInput={(e) => {
                    setpriceUpdateInputState(e.target.value);
                  }}
                  bookingType={bookingDetailsById?.bookingType}
                  countryCodeOnClick={() => {
                    setiscountryListOpen(true);
                  }}
                  priceUpdate={priceUpdateInputState}
                  extraPriceInput={(e) => {
                    setextraPay(e.target.value);
                  }}
                  extraPriceUpdate={extraPay}
                  extraHourInput={(e) => {
                    setextraHour(e.target.value);
                  }}
                  extraHourUpdate={extraHour}
                  currencyInput={(e) => setcurrencyUpdate(e.target.value)}
                  currencyUpdate={currencyUpdate}
                  paxtobeUpdateValuefirst={passengerUpdate?.firstName}
                  paxUpdateInputfirst={(e) => {
                    setpassengerUpdate({
                      ...passengerUpdate,
                      firstName: e.target.value,
                    });
                  }}
                  paxtobeUpdateValuelast={passengerUpdate?.lastName}
                  paxUpdateInputlast={(e) => {
                    setpassengerUpdate({
                      ...passengerUpdate,
                      lastName: e.target.value,
                    });
                  }}
                  codeUpdate={passengerUpdate?.code}
                  codeUpdateInput={(e) => {
                    setiscountryListOpen(true);
                  }}
                  contactNumberUpdate={passengerUpdate?.phone}
                  contactNumberInput={(e) => {
                    setpassengerUpdate({
                      ...passengerUpdate,
                      phone: e.target.value,
                    });
                  }}
                  flightNumberUpdate={passengerUpdate?.flightNumber}
                  flightNumberInput={(e) => {
                    setpassengerUpdate({
                      ...passengerUpdate,
                      flightNumber: e.target.value,
                    });
                  }}
                  referenceNumberInput={(e) => {
                    setpassengerUpdate({
                      ...passengerUpdate,
                      referenceNumber: e.target.value,
                    });
                  }}
                  referenceNumberUpdate={passengerUpdate?.referenceNumber}
                  // paxtobeUpdateValue={}
                  travelDateInput={(e) => {
                    // console.log("travelDateInput",e.target.value)
                    settraveldateUpdate(e.target.value);
                  }}
                  travelDateUpdate={traveldateUpdate}
                  travelTimeUpdate={travelTimeUpdate}
                  travelTimeUpdateInput={(e) => {
                    settravelTimeUpdate(e.target.value);
                  }}
                  durationForAffiliateInput={(e) => {
                    setdurationForAffiliate(e.target.value);
                  }}
                  durationForAffiliateUpdate={durationForAffiliate}
                />
                <div className="absolute top-[45rem] left-1/4 z-50 ">
                  {iscountryListOpen && (
                    <div className="absolute mx-1 overflow-y-auto bg-white border w-52 shadow-2xl -translate-y-9 h-60 scrollbar rounded-bl-md rounded-br-md bottom-2">
                      {/* create a search field where i can search country code and country */}
                      <div>
                        <FontAwesomeIcon
                          icon={faSearch}
                          className="absolute top-3 right-3 text-gray-400"
                        />
                        <input
                          type="text"
                          placeholder="Search Country"
                          className="w-full p-2 border-b-2 border-secondary"
                          value={searchCountry}
                          onChange={(e) => setSearchCountry(e.target.value)}
                        />
                      </div>

                      {CountryList.map(
                        (country) =>
                          country.name
                            .toLowerCase()
                            .includes(searchCountry.toLowerCase()) && (
                            <div
                              onClick={(e) => {
                                setiscountryListOpen(false);
                                console.log("country", country?.dial_code);

                                setpassengerUpdate({
                                  ...passengerUpdate,
                                  country: country?.name,
                                });
                                setpassengerUpdate({
                                  ...passengerUpdate,
                                  code: country?.dial_code,
                                });
                                console.log("passengerUpdate", passengerUpdate);
                                console.log(
                                  "updated code",
                                  passengerUpdate?.code
                                );
                                // dispatch(
                                //   setCountryInput({
                                //     countryInput: country?.name,
                                //   })
                                // );
                                // dispatch(
                                //   setCountryCode({
                                //     countryCode: country?.dial_code,
                                //   })
                                // );
                                // setCountry(country?.name);
                                // setopenContryCode(false);
                              }}
                              className="flex items-center justify-between px-3 space-y-2 text-sm cursor-pointer hover:bg-primary hover:text-white"
                            >
                              <div>{country.name}</div>
                              <div>{country.dial_code}</div>
                            </div>
                          )
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
            {bookingActionModal.paid && (
              <>
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>
                <Modal
                  cancelOnClick={() => setbookingActionModal({ paid: false })}
                  heading={`Confirm Payment for ${bookingDetailsById?.bookingId}`}
                  addButtonLabel="Confirm"
                  addOnClick={paidHandler}
                  isSinglebooingDetailPaid={true}
                  paymentMethodInput={(e) => {
                    setpaymentMethod(e.target.value);
                  }}
                  paymentNoteRef={paymentNoteInputRef}
                />
              </>
            )}
            {bookingActionModal.documents && (
              <>
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>
                <Modal
                  cancelOnClick={() =>
                    setbookingActionModal({ documents: false })
                  }
                  heading={`Documents for ${bookingDetailsById?.bookingId}`}
                  addButtonLabel="Send"
                  addOnClick={() => {
                    sendDocuments();
                  }}
                  isSinglebooingDetailDocuments={true}
                  documentDownloadOnClick={downloadBooking}
                  documentInvoiceChange={(e) => {
                    setDocument({
                      ...document,
                      isInvoice: true,
                      isVoucher: false,
                      isDriver: false,
                    });
                  }}
                  documentVoucherChange={(e) => {
                    setDocument({
                      ...document,
                      isInvoice: false,
                      isVoucher: true,
                      isDriver: false,
                    });
                  }}
                  documentDriverChange={(e) => {
                    setDocument({
                      ...document,
                      isInvoice: false,
                      isVoucher: false,
                      isDriver: true,
                    });
                  }}
                  singleBookingEmailInputValue={invoiceMailToBeSend}
                  singlebookEmailChangeInput={(e) => {
                    setinvoiceMailToBeSend(e.target.value);
                  }}
                />
              </>
            )}
            {bookingActionModal.affiliate && (
              <>
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>
                <Modal
                  cancelOnClick={() => setbookingActionModal({ edit: false })}
                  heading="Assign affiliate"
                  isSinglebookingAffilate={true}
                  addButtonLabel="Save"
                  addOnClick={assignAffiliateHandler}
                  affiliateSelectOnChange={(e) => {
                    setassignAffiliateDetail({
                      ...assignAffiliateDetail,
                      affiliateContact: e?.value?.contact,
                      affiliateId: e?.value?.id,
                      affiliateEmail: e?.value?.email1,
                      affiliateName: e?.label,
                    });
                  }}
                  bookingType={bookingDetailsById?.bookingType}
                  affiliatePurchasePriceinputChange={(e) => {
                    setassignAffiliateDetail({
                      ...assignAffiliateDetail,
                      purchasePrice: e.target.value,
                    });
                  }}
                  affiliatePurchaseCurrencyinputChange={(e) => {
                    setassignAffiliateDetail({
                      ...assignAffiliateDetail,
                      purchaseCurrency: e.target.value,
                    });
                  }}
                  affiliatePurchaseCurrencyinput={
                    assignAffiliateDetail?.purchaseCurrency
                  }
                  affiliatePurchasePriceinput={
                    assignAffiliateDetail?.purchasePrice
                  }
                  affiliateNoteinput={assignAffiliateDetail?.affiliateNote}
                  creditCards={bookingDetailsById?.creditCards}
                  affiliateDetails={bookingDetailsById?.affiliateDetails}
                  affiliateConatct={assignAffiliateDetail?.affiliateContact}
                  affiliateNoteinputChange={(e) => {
                    setassignAffiliateDetail({
                      ...assignAffiliateDetail,
                      affiliateNote: e.target.value,
                    });
                  }}
                />
              </>
            )}
            {bookingActionModal.driver && (
              <>
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>
                <Modal
                  cancelOnClick={() => setbookingActionModal({ edit: false })}
                  heading="Driver"
                  isSingleBookingDriver={true}
                  addOnClick={driverAssignHandler}
                  addButtonLabel="Assign Driver"
                  driverNameInput={(e) => {
                    setassignDriverDetail({
                      ...assignDriverDetail,
                      driverName: e.target.value,
                    });
                  }}
                  driverContactInput={(e) => {
                    setassignDriverDetail({
                      ...assignDriverDetail,
                      driverContact: e.target.value,
                    });
                  }}
                  affiliateSelectOnChange={(e) => {
                    setassignDriverDetail({
                      ...assignDriverDetail,
                      affiliateContact: e?.value?.contact,
                      affiliateId: e?.value?.id,
                    });
                  }}
                />
              </>
            )}
            {bookingActionModal.uploadInvoice && (
              <>
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50 flex justify-center items-center"></div>
                <Modal
                  cancelOnClick={() => setbookingActionModal({ edit: false })}
                  heading="Add Invoice"
                  isSingleBookingUploadInvoice={true}
                  addButtonLabel="Save"
                  addOnClick={uploadInvoiceHandler}
                  invoiceInputChnage={(e) => {
                    setInvoiceData(e.target.value);
                  }}
                />
              </>
            )}
            {/* ------------------------MOBILE VIEW START--------------------- */}
            <div className="xl:hidden block">
              <div className="flex items-center justify-between mt-2">
                <Link to="/manageBooking">
                  <FontAwesomeIcon
                    icon={faArrowCircleLeft}
                    className="w-10 h-6 text-gray-500 ml-1"
                  />
                </Link>
                <div className=" text-md text-primary font-semibold">
                  Booking Summary
                </div>
                <button
                  onClick={() => {
                    setopenSummaryNav(true);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faGear}
                    className="text-secondary mr-3"
                  />
                </button>

                {openSummaryNav && (
                  <div
                    className="bg-black w-screen h-screen fixed top-0 left-0 bg-opacity-50 flex justify-center items-center"
                    onClick={() => {
                      setopenSummaryNav(false);
                    }}
                  ></div>
                )}
              </div>

              <div className="flex space-x-2 mt-2 px-3">
                <div className="text-black text-sm font-normal mt-0.5">
                  Booked by:{" "}
                </div>
                <div>
                  <div className="flex space-x-1 items-center">
                    <div>
                      <FontAwesomeIcon
                        icon={faUser}
                        className="w-3 text-gray-500"
                      />
                    </div>
                    <div className="text-sm font-normal">
                      {bookingDetailsById?.userName}
                    </div>
                  </div>
                  <div className="flex space-x-1 items-center">
                    <div>
                      <FontAwesomeIcon
                        icon={faBuilding}
                        className="w-3 text-gray-500"
                      />
                    </div>
                    <div className="text-sm font-normal">
                      {allCompany?.map((company) => {
                        return company?.users?.map((user) => {
                          return (
                            user?.userName ===
                              bookingDetailsById?.userName?.split(" ")[0] && (
                              <div>{company?.companyName}</div>
                            )
                          );
                        });
                      })}
                    </div>
                  </div>
                </div>
                {openSummaryNav && (
                  <div className="w-60 h-full absolute right-0 bg-white shadow-2xl">
                    <div className="text-black space-y-5 py-9 space-x-7">
                      {/* FOR CANCEL BOOKING BASED ON PERMISSION */}
                      {user?.role === "ADMIN" && (
                        <button
                          disabled={
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? true
                              : false
                          }
                          onClick={() => {
                            setbookingActionModal({
                              ...bookingActionModal,
                              cancel: true,
                            });
                          }}
                          className={`flex items-center ml-7 space-x-1 text-sm ${
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? "text-gray-500 cursor-not-allowed"
                              : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                          }  h-5 `}
                        >
                          <FontAwesomeIcon icon={faXmark} className="w-6" />
                          <div className=" ">Cancel</div>
                        </button>
                      )}

                      {user?.role !== "ADMIN" &&
                        user?.permission?.manageBooking?.cancelBooking
                          ?.permission === "ENABLE" &&
                        user?.userName === bookingDetailsById?.userName && (
                          <>
                            <button
                              disabled={
                                bookingDetailsById?.bookingStatus ===
                                "CANCELLED"
                                  ? true
                                  : false
                              }
                              onClick={() => {
                                setbookingActionModal({
                                  ...bookingActionModal,
                                  cancel: true,
                                });
                              }}
                              className={`flex items-center  space-x-1 text-sm ${
                                bookingDetailsById?.bookingStatus ===
                                "CANCELLED"
                                  ? "text-gray-500 cursor-not-allowed"
                                  : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                              }  h-5 `}
                            >
                              <FontAwesomeIcon icon={faXmark} className="w-6" />
                              <div className=" ">Cancel</div>
                            </button>
                          </>
                        )}

                      {user?.role !== "ADMIN" &&
                        user?.permission?.manageBooking?.cancelBooking
                          ?.permission === "BRANCH_LEVEL" &&
                        userCompany?.users.map(
                          (user) =>
                            bookingDetailsById?.userName === user?.userName && (
                              <>
                                <button
                                  disabled={
                                    bookingDetailsById?.bookingStatus ===
                                    "CANCELLED"
                                      ? true
                                      : false
                                  }
                                  onClick={() => {
                                    setbookingActionModal({
                                      ...bookingActionModal,
                                      cancel: true,
                                    });
                                  }}
                                  className={`flex items-center  space-x-1 text-sm ${
                                    bookingDetailsById?.bookingStatus ===
                                    "CANCELLED"
                                      ? "text-gray-500 cursor-not-allowed"
                                      : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                                  }  h-5 `}
                                >
                                  <FontAwesomeIcon
                                    icon={faXmark}
                                    className="w-6"
                                  />
                                  <div className=" ">Cancel</div>
                                </button>
                              </>
                            )
                        )}

                      {user?.role !== "ADMIN" &&
                        user?.permission?.manageBooking?.cancelBooking
                          ?.permission === "CHILD_COMPANY" &&
                        userCompany?.company?.map((userCom) =>
                          allCompany?.map(
                            (company) =>
                              (company?._id === userCom?._id ||
                                company?._id === userCompany?._id) &&
                              company?.users.map(
                                (user) =>
                                  bookingDetailsById?.userName ===
                                    user?.userName && (
                                    <>
                                      <button
                                        disabled={
                                          bookingDetailsById?.bookingStatus ===
                                          "CANCELLED"
                                            ? true
                                            : false
                                        }
                                        onClick={() => {
                                          setbookingActionModal({
                                            ...bookingActionModal,
                                            cancel: true,
                                          });
                                        }}
                                        className={`flex items-center  space-x-1 text-sm ${
                                          bookingDetailsById?.bookingStatus ===
                                          "CANCELLED"
                                            ? "text-gray-500 cursor-not-allowed"
                                            : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                                        }  h-5 `}
                                      >
                                        <FontAwesomeIcon
                                          icon={faXmark}
                                          className=""
                                        />
                                        <div className=" ">Cancel</div>
                                      </button>
                                    </>
                                  )
                              )
                          )
                        )}

                      {user?.role === "ADMIN" && (
                        <button
                          disabled={
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? true
                              : false
                          }
                          onClick={() => {
                            setbookingActionModal({
                              ...bookingActionModal,
                              paid: true,
                            });
                          }}
                          className={`flex items-center  space-x-1 text-sm ${
                            bookingDetailsById?.bookingStatus === "CANCELLED" ||
                            bookingDetailsById?.paymentStatus === "PAID"
                              ? "text-green-500"
                              : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                          }  h-5 `}
                        >
                          <FontAwesomeIcon icon={faCoins} className="w-6" />
                          <div> Paid</div>
                        </button>
                      )}
                      {user?.role === "ADMIN" && (
                        <button
                          disabled={
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? true
                              : false
                          }
                          className={`flex items-center  space-x-1 text-sm ${
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? "text-gray-500 cursor-not-allowed"
                              : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                          }  h-5 `}
                        >
                          <FontAwesomeIcon
                            icon={faMoneyBillWave}
                            className="w-6"
                          />

                          <div>Refund</div>
                        </button>
                      )}
                      <button
                        disabled={
                          bookingDetailsById?.bookingStatus === "CANCELLED"
                            ? true
                            : false
                        }
                        onClick={() => {
                          setbookingActionModal({
                            ...bookingActionModal,
                            documents: true,
                          });
                        }}
                        className={`flex items-center  space-x-1 text-sm ${
                          bookingDetailsById?.bookingStatus === "CANCELLED"
                            ? "text-gray-500 cursor-not-allowed"
                            : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                        }  h-5 `}
                      >
                        <FontAwesomeIcon icon={faFile} className="w-6" />

                        <div>Documents</div>
                      </button>
                      {user?.role === "ADMIN" && (
                        <button
                          onClick={() => {
                            dispatch({
                              type: "SEND_WATI_MSG",
                              payload: {
                                bookingId: bookingDetailsById?.bookingId,
                              },
                            });
                            dispatch({
                              type: "BOOKING_HISTORY_CREATE",
                              payload: {
                                body: {
                                  booking: bookingDetailsById?._id,
                                  userName: user?.userName,
                                  updateItem: "Whatsapp Message Sent",
                                },
                                token,
                                bookingId: bookingDetailsById?._id,
                              },
                            });
                          }}
                          disabled={
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? true
                              : false
                          }
                          className={`flex items-center  space-x-1 text-sm ${
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? "text-gray-500 cursor-not-allowed"
                              : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                          }  h-5 `}
                        >
                          <FontAwesomeIcon icon={faWhatsapp} className="w-6" />
                          <div>Whatsapp</div>
                        </button>
                      )}
                      {user?.role === "ADMIN" && (
                        <button
                          disabled={
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? true
                              : false
                          }
                          onClick={() => {
                            setbookingActionModal({
                              ...bookingActionModal,
                              edit: true,
                            });
                            setpriceUpdateInputState(
                              Math.round(
                                bookingDetailsById?.priceDetails?.amount
                              )
                            );
                            setcurrencyUpdate(
                              bookingDetailsById?.priceDetails?.currency
                            );
                            console.log(
                              bookingDetailsById?.priceDetails?.currency,
                              "check on click"
                            );
                            setextraHour(bookingDetailsById?.extraHour);
                            setextraPay(bookingDetailsById?.extraPay);
                            setdurationForAffiliate(
                              bookingDetailsById?.durationForAffiliate
                            );
                            setdurationForAffiliate(
                              bookingDetailsById?.durationForAffiliate
                            );
                            settravelTimeUpdate(bookingDetailsById?.travelTime);
                            settraveldateUpdate(bookingDetailsById?.travelDate);
                            setpassengerUpdate({
                              firstName:
                                bookingDetailsById?.passengerDetails?.firstName,
                              lastName:
                                bookingDetailsById?.passengerDetails?.lastName,
                              flightNumber:
                                bookingDetailsById?.passengerDetails
                                  ?.flightNumber,
                              code: bookingDetailsById?.passengerDetails?.code,
                              country:
                                bookingDetailsById?.passengerDetails?.country,
                              phone:
                                bookingDetailsById?.passengerDetails?.phone,
                            });
                          }}
                          className={`flex items-center  space-x-1 text-sm ${
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? "text-gray-500 cursor-not-allowed"
                              : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                          }  h-5 `}
                        >
                          <FontAwesomeIcon icon={faPencil} className="w-6" />

                          <div>Edit Booking</div>
                        </button>
                      )}
                      {user?.role === "ADMIN" && (
                        <button
                          disabled={
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? true
                              : false
                          }
                          onClick={() => {
                            setassignAffiliateDetail({
                              ...assignAffiliateDetail,
                              purchasePrice: bookingDetailsById?.purchasePrice,
                              purchaseCurrency:
                                bookingDetailsById?.purchaseCurrency,
                              affiliateNote: bookingDetailsById?.affiliateNote,
                            });
                            setbookingActionModal({
                              ...bookingActionModal,
                              affiliate: true,
                            });
                          }}
                          className={`flex items-center  space-x-1 text-sm ${
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? "text-gray-500 cursor-not-allowed"
                              : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                          }  h-5 `}
                        >
                          <FontAwesomeIcon icon={faUsersRays} className="w-6" />

                          <div>Assign Ride</div>
                        </button>
                      )}
                      {user?.role === "ADMIN" && (
                        <button
                          disabled={
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? true
                              : false
                          }
                          onClick={() => {
                            setisBookingClone(true);
                          }}
                          className={`flex items-center  space-x-1 text-sm ${
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? "text-gray-500 cursor-not-allowed"
                              : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                          }  h-5 `}
                        >
                          <FontAwesomeIcon icon={faUserTie} className="w-6" />

                          <div>Clone</div>
                        </button>
                      )}
                      {bookingDetailsById?.invoice && (
                        <a
                          href={bookingDetailsById?.invoice?.secure_url}
                          rel="noreferrer"
                          target="_blank"
                        >
                          <div className="flex items-center text-sm space-x-1 hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer h-5">
                            <FontAwesomeIcon
                              icon={faEye}
                              className="text-teal-700"
                            />

                            <div className="text-green-700">View Invoice</div>
                          </div>
                        </a>
                      )}
                      {user?.role === "ADMIN" && (
                        <button
                          disabled={
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? true
                              : false
                          }
                          onClick={() => {
                            setbookingActionModal({
                              ...bookingActionModal,
                              uploadInvoice: true,
                            });
                          }}
                          className={`flex items-center  space-x-1 text-sm ${
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? "text-gray-500 cursor-not-allowed"
                              : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                          }  h-5 `}
                        >
                          {bookingDetailsById?.invoice ? (
                            <FontAwesomeIcon
                              icon={faFileCircleCheck}
                              className="text-teal-700"
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faFileUpload}
                              className="w-6"
                            />
                          )}
                          {bookingDetailsById?.invoice ? (
                            <div className="text-green-700">
                              Invoice Uploaded
                            </div>
                          ) : (
                            <div>Upload Invoice</div>
                          )}
                        </button>
                      )}
                      {user?.role === "ADMIN" && (
                        <button
                          onClick={() => {
                            setopenHistory(true);
                          }}
                        >
                          <div className="flex items-center text-sm space-x-1 hover:text-primary cursor-pointer h-5">
                            <FontAwesomeIcon
                              icon={faClockRotateLeft}
                              className="w-6"
                            />

                            <div className="">History</div>
                          </div>
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* -----------------DESKTOP VIEW START------------------ */}
            <div className="shadow-md hidden xl:block">
              <div className="px-3 py-2 flex justify-between items-center  ">
                <div className="flex items-center space-x-2">
                  <Link to="/manageBooking">
                    <FontAwesomeIcon
                      icon={faArrowCircleLeft}
                      className="w-10 h-6 mt-1 text-gray-500"
                    />
                  </Link>
                  <div className=" text-xl text-primary font-semibold">
                    Booking Summary
                  </div>
                </div>
                {uploadingInvoiceStatus && (
                  <div>
                    {/* <div>Uploading Invoice...</div> */}
                    <div>
                      <LinearProgress />
                    </div>
                  </div>
                )}
                {!bookingDetailsById?.invoice_code_num
                  ?.slice("-")
                  .includes("DIO") && (
                  <div className="flex items-center space-x-3 text-sm bg-gradient-to-r from-teal-700 to-teal-800 rounded-full px-3 py-1 text-white">
                    <div>Invoice Number:</div>
                    <div>{bookingDetailsById?.invoice_code_num}</div>
                  </div>
                )}

                <div className="flex space-x-2">
                  <div className="text-gray-600 font-semibold">Booked by: </div>
                  <div>
                    <div className="flex space-x-1">
                      <div>
                        <FontAwesomeIcon
                          icon={faUser}
                          className="w-5 text-gray-500"
                        />
                      </div>
                      <div>{bookingDetailsById?.userName}</div>
                    </div>
                    <div className="flex space-x-1">
                      <div>
                        <FontAwesomeIcon
                          icon={faBuilding}
                          className="w-5 text-gray-500"
                        />
                      </div>
                      <div>
                        {allCompany?.map((company) => {
                          return company?.users?.map((user) => {
                            return (
                              user?.userName ===
                                bookingDetailsById?.userName?.split(" ")[0] && (
                                <div>{company?.companyName}</div>
                              )
                            );
                          });
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex bg-red-100 text-black space-x-7 py-2  justify-center mx-3.5 rounded-t-md  ">
                {/* FOR CANCEL BOOKING BASED ON PERMISSION */}
                {user?.role === "ADMIN" &&
                  bookingDetailsById?.bookingStatus !== "ONREQUEST" && (
                    <button
                      disabled={
                        bookingDetailsById?.bookingStatus === "CANCELLED"
                          ? true
                          : false
                      }
                      onClick={() => {
                        setbookingActionModal({
                          ...bookingActionModal,
                          cancel: true,
                        });
                      }}
                      className={`flex items-center  space-x-1 text-sm ${
                        bookingDetailsById?.bookingStatus === "CANCELLED"
                          ? "text-gray-500 cursor-not-allowed"
                          : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                      }  h-5 `}
                    >
                      <FontAwesomeIcon icon={faXmark} className="" />
                      <div className=" ">Cancel</div>
                    </button>
                  )}

                {user?.role !== "ADMIN" &&
                  bookingDetailsById?.bookingStatus !== "ONREQUEST" &&
                  user?.permission?.manageBooking?.cancelBooking?.permission ===
                    "ENABLE" &&
                  user?.userName === bookingDetailsById?.userName && (
                    <>
                      <button
                        disabled={
                          bookingDetailsById?.bookingStatus === "CANCELLED"
                            ? true
                            : false
                        }
                        onClick={() => {
                          setbookingActionModal({
                            ...bookingActionModal,
                            cancel: true,
                          });
                        }}
                        className={`flex items-center  space-x-1 text-sm ${
                          bookingDetailsById?.bookingStatus === "CANCELLED"
                            ? "text-gray-500 cursor-not-allowed"
                            : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                        }  h-5 `}
                      >
                        <FontAwesomeIcon icon={faXmark} className="" />
                        <div className=" ">Cancel</div>
                      </button>
                    </>
                  )}

                {user?.role !== "ADMIN" &&
                  bookingDetailsById?.bookingStatus !== "ONREQUEST" &&
                  user?.permission?.manageBooking?.cancelBooking?.permission ===
                    "BRANCH_LEVEL" &&
                  userCompany?.users.map(
                    (user) =>
                      bookingDetailsById?.userName === user?.userName && (
                        <>
                          <button
                            disabled={
                              bookingDetailsById?.bookingStatus === "CANCELLED"
                                ? true
                                : false
                            }
                            onClick={() => {
                              setbookingActionModal({
                                ...bookingActionModal,
                                cancel: true,
                              });
                            }}
                            className={`flex items-center  space-x-1 text-sm ${
                              bookingDetailsById?.bookingStatus === "CANCELLED"
                                ? "text-gray-500 cursor-not-allowed"
                                : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                            }  h-5 `}
                          >
                            <FontAwesomeIcon icon={faXmark} className="" />
                            <div className=" ">Cancel</div>
                          </button>
                        </>
                      )
                  )}

                {user?.role !== "ADMIN" &&
                  bookingDetailsById?.bookingStatus !== "ONREQUEST" &&
                  user?.permission?.manageBooking?.cancelBooking?.permission ===
                    "CHILD_COMPANY" &&
                  userCompany?.company?.map((userCom) =>
                    allCompany?.map(
                      (company) =>
                        (company?._id === userCom?._id ||
                          company?._id === userCompany?._id) &&
                        company?.users.map(
                          (user) =>
                            bookingDetailsById?.userName === user?.userName && (
                              <>
                                <button
                                  disabled={
                                    bookingDetailsById?.bookingStatus ===
                                    "CANCELLED"
                                      ? true
                                      : false
                                  }
                                  onClick={() => {
                                    setbookingActionModal({
                                      ...bookingActionModal,
                                      cancel: true,
                                    });
                                  }}
                                  className={`flex items-center  space-x-1 text-sm ${
                                    bookingDetailsById?.bookingStatus ===
                                    "CANCELLED"
                                      ? "text-gray-500 cursor-not-allowed"
                                      : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                                  }  h-5 `}
                                >
                                  <FontAwesomeIcon
                                    icon={faXmark}
                                    className=""
                                  />
                                  <div className=" ">Cancel</div>
                                </button>
                              </>
                            )
                        )
                    )
                  )}

                {user?.role === "ADMIN" && (
                  <button
                    disabled={
                      bookingDetailsById?.bookingStatus === "CANCELLED"
                        ? true
                        : false
                    }
                    onClick={() => {
                      setbookingActionModal({
                        ...bookingActionModal,
                        paid: true,
                      });
                    }}
                    className={`flex items-center  space-x-1 text-sm ${
                      bookingDetailsById?.bookingStatus === "CANCELLED" ||
                      bookingDetailsById?.paymentStatus === "PAID"
                        ? "text-green-500"
                        : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                    }  h-5 `}
                  >
                    <FontAwesomeIcon icon={faCoins} className="" />
                    <div> Paid</div>
                  </button>
                )}
                {user?.role === "ADMIN" && (
                  <button
                    disabled={
                      bookingDetailsById?.bookingStatus === "CANCELLED"
                        ? true
                        : false
                    }
                    className={`flex items-center  space-x-1 text-sm ${
                      bookingDetailsById?.bookingStatus === "CANCELLED"
                        ? "text-gray-500 cursor-not-allowed"
                        : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                    }  h-5 `}
                  >
                    <FontAwesomeIcon icon={faMoneyBillWave} className="" />

                    <div>Refund</div>
                  </button>
                )}
                <button
                  disabled={
                    bookingDetailsById?.bookingStatus === "CANCELLED"
                      ? true
                      : false
                  }
                  onClick={() => {
                    setbookingActionModal({
                      ...bookingActionModal,
                      documents: true,
                    });
                  }}
                  className={`flex items-center  space-x-1 text-sm ${
                    bookingDetailsById?.bookingStatus === "CANCELLED"
                      ? "text-gray-500 cursor-not-allowed"
                      : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                  }  h-5 `}
                >
                  <FontAwesomeIcon icon={faFile} className="" />

                  <div>Documents</div>
                </button>
                {user?.role === "ADMIN" && (
                  <button
                    onClick={() => {
                      dispatch({
                        type: "SEND_WATI_MSG",
                        payload: {
                          bookingId: bookingDetailsById?.bookingId,
                        },
                      });
                    }}
                    disabled={
                      bookingDetailsById?.bookingStatus === "CANCELLED"
                        ? true
                        : false
                    }
                    className={`flex items-center  space-x-1 text-sm ${
                      bookingDetailsById?.bookingStatus === "CANCELLED"
                        ? "text-gray-500 cursor-not-allowed"
                        : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                    }  h-5 `}
                  >
                    <FontAwesomeIcon icon={faWhatsapp} className="" />
                    <div>Whatsapp</div>
                  </button>
                )}
                {(user?.role === "ADMIN" ||
                  (user?.role === "USER" &&
                    user?.permission?.manageBooking?.editBooking?.permission ===
                      "ENABLE")) && (
                  <button
                    disabled={
                      bookingDetailsById?.bookingStatus === "CANCELLED" &&
                      user?.role === "USER"
                        ? true
                        : false
                    }
                    onClick={() => {
                      if (user.role === "USER") {
                        const date_time = `${momenttz
                          .utc(bookingDetailsById?.travelDate)
                          .format("YYYY-MM-DD")}T${
                          bookingDetailsById?.travelTime
                        }:00`;
                        const utc24HoursBefore = momenttz
                          .utc(date_time)
                          .subtract(24, "hours")
                          .format();

                        //  console.log("utc24HoursBefore=====>", utc24HoursBefore);
                        //  console.log("date_time=====>", date_time);

                        const currentDate = momenttz.tz(timeZone).format();

                        // console.log("currentDate=====>", currentDate);
                        if (currentDate > utc24HoursBefore) {
                          // console.log("FALSEEEEEEEEEE,Cannot edit date");
                          setIsBookingEditable(false);
                          dispatch(
                            setEditBookingError({
                              editBookingError:
                                "Date and time cannot be edited within 24hours",
                            })
                          );
                        } else {
                          // console.log("TRUEEEEEEEE,edit date");
                          setIsBookingEditable(true);
                        }
                      }
                      if (user.role === "ADMIN") {
                        setIsBookingEditable(true);
                      }

                      setbookingActionModal({
                        ...bookingActionModal,
                        edit: true,
                      });
                      setpriceUpdateInputState(
                        Math.round(bookingDetailsById?.priceDetails?.amount)
                      );
                      settravelTimeUpdate(bookingDetailsById?.travelTime);
                      settraveldateUpdate(bookingDetailsById?.travelDate);
                      setcurrencyUpdate(
                        bookingDetailsById?.priceDetails?.currency
                      );
                      console.log(
                        bookingDetailsById?.priceDetails?.currency,
                        "check on click"
                      );
                      setextraPay(bookingDetailsById?.extraPay);
                      setextraHour(bookingDetailsById?.extraHour);
                      setpassengerUpdate({
                        firstName:
                          bookingDetailsById?.passengerDetails?.firstName,
                        lastName:
                          bookingDetailsById?.passengerDetails?.lastName,
                        flightNumber:
                          bookingDetailsById?.passengerDetails?.flightNumber,
                        code: bookingDetailsById?.passengerDetails?.code,
                        country: bookingDetailsById?.passengerDetails?.country,
                        phone: bookingDetailsById?.passengerDetails?.phone,
                        referenceNumber:
                          bookingDetailsById?.passengerDetails?.referenceNumber,
                      });
                    }}
                    className={`flex items-center  space-x-1 text-sm ${
                      bookingDetailsById?.bookingStatus === "CANCELLED" &&
                      user?.role === "USER"
                        ? "text-gray-500 cursor-not-allowed"
                        : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                    }  h-5 `}
                  >
                    <FontAwesomeIcon icon={faPencil} className="" />

                    <div>Edit Booking</div>
                  </button>
                )}
                {user?.role === "ADMIN" && (
                  <button
                    disabled={
                      bookingDetailsById?.bookingStatus === "CANCELLED" &&
                      user?.role === "USER"
                        ? true
                        : false
                    }
                    onClick={() => {
                      setassignAffiliateDetail({
                        ...assignAffiliateDetail,
                        purchasePrice: bookingDetailsById?.purchasePrice,
                        purchaseCurrency: bookingDetailsById?.purchaseCurrency,
                        affiliateNote: bookingDetailsById?.affiliateNote,
                      });
                      setbookingActionModal({
                        ...bookingActionModal,
                        affiliate: true,
                      });
                    }}
                    className={`flex items-center  space-x-1 text-sm ${
                      bookingDetailsById?.bookingStatus === "CANCELLED" &&
                      user?.role === "USER"
                        ? "text-gray-500 cursor-not-allowed"
                        : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                    }  h-5 `}
                  >
                    <FontAwesomeIcon icon={faUsersRays} className="" />

                    <div>Assign Ride</div>
                  </button>
                )}
                {user?.role === "ADMIN" && (
                  <button
                    disabled={
                      bookingDetailsById?.bookingStatus === "CANCELLED"
                        ? true
                        : false
                    }
                    onClick={() => {
                      setisBookingClone(true);

                      setclonedBookingDetail({
                        company_name: companyName,
                        emergency_number:
                          settings?.emergencyContact1 +
                          " " +
                          settings?.emergencyContact2 +
                          " " +
                          settings?.emergencyContact3,
                        bookingPriceInUsd:
                          bookingDetailsById?.bookingPriceInUsd,
                        bookingStatus: bookingDetailsById?.bookingStatus,
                        bookingType: bookingDetailsById?.bookingType,
                        cancellationFee: bookingDetailsById?.cancellationFee,

                        isSearch: bookingDetailsById?.isSearch,
                        passenger: bookingDetailsById?.passenger,
                        passengerDetails: {
                          code: bookingDetailsById?.passengerDetails?.code,
                          country:
                            bookingDetailsById?.passengerDetails?.country,
                          flightNumber:
                            bookingDetailsById?.passengerDetails?.flightNumber,
                          firstName:
                            bookingDetailsById?.passengerDetails?.firstName,
                          lastName:
                            bookingDetailsById?.passengerDetails?.lastName,
                          phone: bookingDetailsById?.passengerDetails?.phone,
                          email: bookingDetailsById?.passengerDetails?.email,
                          referenceNumber:
                            bookingDetailsById?.passengerDetails
                              ?.referenceNumber,
                          specialRequest:
                            bookingDetailsById?.passengerDetails
                              ?.specialRequest,
                        },
                        paymentStatus: bookingDetailsById?.paymentStatus, //!
                        priceDetails: {
                          amount: bookingDetailsById?.priceDetails?.amount,
                          currency: bookingDetailsById?.priceDetails?.currency,
                        },
                        destination: {
                          lat: bookingDetailsById?.destination?.lat,
                          lng: bookingDetailsById?.destination?.lng,
                          placeid: bookingDetailsById?.destination?.placeid,
                          placename: bookingDetailsById?.destination?.placename,
                        },

                        source: {
                          lat: bookingDetailsById?.source?.lat,
                          lng: bookingDetailsById?.source?.lng,
                          placeid: bookingDetailsById?.source?.placeid,
                          placename: bookingDetailsById?.source?.placename,
                        },
                        travelDistance: bookingDetailsById?.travelDistance,
                        duration: bookingDetailsById?.duration,
                        userName: user?.userName + " (cloned)",
                        vehicleDetails: bookingDetailsById?.vehicleDetails?._id,
                      });
                    }}
                    className={`flex items-center  space-x-1 text-sm ${
                      bookingDetailsById?.bookingStatus === "CANCELLED"
                        ? "text-gray-500 cursor-not-allowed"
                        : "hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer"
                    }  h-5 `}
                  >
                    <FontAwesomeIcon icon={faCopy} className="" />

                    <div>Clone</div>
                  </button>
                )}

                {/* {isBookingClone && (
                  <div className="absolute animate__animated animate__fadeIn bg-white shadow-lg w-1/2 text-center px-2 py-1 rounded-md space-x-5 ">
                    <div className="flex space-x-4 text-sm ">
                      <div>
                        <div>Travel Date</div>
                        <input
                          type="date"
                          onChange={(e) => {
                            setclonedBookingDetail({
                              ...clonedBookingDetail,
                              travelDate: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div>
                        <div>Travel Time</div>
                        <input
                          type="time"
                          onChange={(e) => {
                            setclonedBookingDetail({
                              ...clonedBookingDetail,
                              travelTime: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        setisBookingClone(false);
                        setclonedBookingDetail({});
                      }}
                      className="bg-red-600 px-1 py-1 text-sm rounded-md text-white"
                    >
                      Discard
                    </button>
                    <button
                      onClick={() => {
                        // if (clonedBookingDetail?.travelTimeStamp) {

                        dispatch({
                          type: "CREATE_DUPLICATE_BOOKING",
                          payload: { body: clonedBookingDetail, token },
                        });
                        dispatch({
                          type: "BOOKING_HISTORY_CREATE",
                          payload: {
                            body: {
                              booking: bookingDetailsById?._id,
                              userName: user?.userName,
                              updateItem: "Booking Cloned",
                            },
                            token,
                            bookingId: bookingDetailsById?._id,
                          },
                        });
                        setisBookingClone(false);
                        // }
                      }}
                      className="bg-teal-600 px-1 py-1 text-sm rounded-md text-white"
                    >
                      Publish
                    </button>
                  </div>
                )} */}
                {multiCloneBookingLoading && (
                  <>
                    <div className="p-10 h-full justify-center items-center absolute z-50">
                      <LoadingSpinner classname="border-red-700 h-24 w-24" />
                    </div>
                  </>
                )}

                {isBookingClone && (
                  <div className="absolute animate__animated animate__fadeIn bg-white shadow-lg w-1/2 text-center px-2 py-5 rounded-md space-x-5 z-50">
                    {/* Radio Buttons for Clone Type */}
                    <div className="flex justify-center space-x-5 mb-4 items-center">
                      <div className="space-x-2">
                        <input
                          type="radio"
                          name="cloneType"
                          value="single"
                          checked={cloneType === "single"}
                          onChange={() => setCloneType("single")}
                        />
                        <label>Single Clone</label>
                      </div>
                      <div className="space-x-2">
                        <input
                          type="radio"
                          name="cloneType"
                          value="multi"
                          checked={cloneType === "multi"}
                          onChange={() => setCloneType("multi")}
                        />
                        <label>Multi Clone</label>
                      </div>
                    </div>

                    {cloneType === "single" ? (
                      /* Single Clone Layout */
                      <div>
                        <div className="flex space-x-4 text-sm">
                          <div>
                            <div>Travel Date</div>
                            <input
                              type="date"
                              onChange={(e) => {
                                setclonedBookingDetail({
                                  ...clonedBookingDetail,
                                  travelDate: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div>
                            <div>Travel Time</div>
                            <input
                              type="time"
                              onChange={(e) => {
                                setclonedBookingDetail({
                                  ...clonedBookingDetail,
                                  travelTime: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      /* Multi-Clone Layout */
                      <div>
                        <div className="flex space-x-4 text-sm">
                          <div>
                            <div>First Date</div>
                            <input
                              type="date"
                              min={minDate}
                              onChange={(e) => {
                                setMultiClonedBookingDetail({
                                  ...multiClonedBookingDetail,
                                  firstDate: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div>
                            <div>Last Date</div>
                            <input
                              type="date"
                              onChange={(e) => {
                                setMultiClonedBookingDetail({
                                  ...multiClonedBookingDetail,
                                  lastDate: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div>
                            <div>Travel Time</div>
                            <input
                              type="time"
                              onChange={(e) => {
                                setMultiClonedBookingDetail({
                                  ...multiClonedBookingDetail,
                                  travelTime: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>

                        {/* Group Options */}
                        <div className="flex space-x-5 mt-4 justify-start items-center">
                          <div className="flex space-x-2 ">
                            <input
                              type="radio"
                              name="groupOption"
                              value="addToGroup"
                              checked={groupOption === "addToGroup"}
                              onChange={() => setGroupOption("addToGroup")}
                            />
                            <label className="w-36 ">Add to Group</label>
                          </div>
                          <div className="flex space-x-2">
                            <input
                              type="radio"
                              name="groupOption"
                              value="createGroup"
                              checked={groupOption === "createGroup"}
                              onChange={() => setGroupOption("createGroup")}
                            />
                            <label className="w-40">Create a New Group</label>
                          </div>
                          <div className="flex space-x-2">
                            <input
                              type="radio"
                              name="groupOption"
                              value="noGroup"
                              checked={groupOption === ""}
                              onChange={() => setGroupOption("")}
                            />
                            <label className="w-28">No Group</label>
                          </div>
                        </div>

                        {/* Dynamic Group Input Field */}
                        <div className="flex space-x-4 mt-4 justify-start items-center h-8">
                          <label className="w-40">
                            {groupOption === "addToGroup" ? (
                              "Enter Group Name"
                            ) : groupOption === "createGroup" ? (
                              <>
                                <div
                                  className="bg-red-100 rounded-xl cursor-pointer hover:bg-red-400 hover:text-white"
                                  onClick={() => {
                                    generateGroupId();
                                  }}
                                >
                                  Created Group
                                </div>
                              </>
                            ) : (
                              "No group selected"
                            )}
                          </label>
                          {groupOption !== "" && (
                            <>
                              <input
                                type="text"
                                className="border rounded-md px-2 py-1"
                                value={multiClonedBookingDetail.groupName || ""}
                                onChange={(e) => {
                                  if (groupOption === "addToGroup") {
                                    setMultiClonedBookingDetail({
                                      ...multiClonedBookingDetail,
                                      groupName: e.target.value
                                        .toUpperCase()
                                        .trim(),
                                    });
                                  }
                                }}
                                readOnly={
                                  groupOption === "createGroup" ||
                                  groupOption === ""
                                }
                                placeholder={
                                  groupOption === "createGroup"
                                    ? "Generated Group Name"
                                    : "Enter Group Name"
                                }
                              />
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Buttons */}
                    <div className="flex justify-center space-x-4 mt-4">
                      <button
                        onClick={() => {
                          if (cloneType === "single") {
                            setisBookingClone(false);
                            setclonedBookingDetail({});
                          } else {
                            setisBookingClone(false);
                            setMultiClonedBookingDetail({});
                          }
                        }}
                        className="bg-red-600 px-2 py-1 text-sm rounded-md text-white"
                      >
                        Discard
                      </button>
                      <button
                        onClick={() => {
                          if (cloneType === "single") {
                            dispatch({
                              type: "CREATE_DUPLICATE_BOOKING",
                              payload: { body: clonedBookingDetail, token },
                            });
                          } else if (cloneType === "multi") {
                            dispatch({
                              type: "CREATE_MULTIPLE_DUPLICATE_BOOKING",
                              payload: {
                                ...multiClonedBookingDetail,
                                groupOption: groupOption,
                                companyAddress: companyDetails?.address,
                                companyLogo:
                                  companyDetails?.companyLogo?.secure_url,
                                companyEmail: companyDetails?.email,
                                company_name: companyDetails?.companyName,
                                userName: user?.userName,
                                bookingId: bookingDetailsById?.bookingId,
                                passengerId:
                                  bookingDetailsById?.passengerDetails?._id,
                                token,
                              },
                            });
                            setMultiClonedBookingDetail({});
                            setGroupOption("");
                            setCloneType("single");
                          }

                          if (cloneType === "single") {
                            dispatch({
                              type: "BOOKING_HISTORY_CREATE",
                              payload: {
                                body: {
                                  booking: bookingDetailsById?._id,
                                  userName: user?.userName,
                                  updateItem:
                                    cloneType === "single"
                                      ? "Booking Cloned"
                                      : "Multi-Booking Cloned",
                                },
                                token,
                                bookingId: bookingDetailsById?._id,
                              },
                            });
                          }
                          setisBookingClone(false);
                        }}
                        className="bg-teal-600 px-2 py-1 text-sm rounded-md text-white"
                      >
                        Publish
                      </button>
                    </div>
                  </div>
                )}

                {bookingDetailsById?.invoice && (
                  <a
                    href={bookingDetailsById?.invoice?.secure_url}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <div className="flex items-center text-sm space-x-1 hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer h-5">
                      <FontAwesomeIcon icon={faEye} className="text-teal-700" />

                      <div className="text-green-700">View Invoice</div>
                    </div>
                  </a>
                )}
                {user?.role === "ADMIN" && (
                  <button
                    onClick={() => {
                      setbookingActionModal({
                        ...bookingActionModal,
                        uploadInvoice: true,
                      });
                    }}
                    className={`flex items-center  space-x-1 text-sm hover:text-primary hover:border-primary hover:border-b-2 cursor-pointer  h-5 `}
                  >
                    {bookingDetailsById?.invoice ? (
                      <FontAwesomeIcon
                        icon={faFileCircleCheck}
                        className="text-teal-700"
                      />
                    ) : (
                      <FontAwesomeIcon icon={faFile} className="" />
                    )}
                    {bookingDetailsById?.invoice ? (
                      <div className="text-green-700">Invoice Uploaded</div>
                    ) : (
                      <div>Invoice</div>
                    )}
                  </button>
                )}
                {user?.role === "ADMIN" && (
                  <button
                    onClick={() => {
                      setopenHistory(true);
                    }}
                  >
                    <div className="flex items-center text-sm space-x-1 hover:text-primary cursor-pointer h-5">
                      <FontAwesomeIcon icon={faClockRotateLeft} className="" />

                      <div className="">History</div>
                    </div>
                  </button>
                )}
              </div>
            </div>
            <div></div>
            {/* ---------------------MOBILE VIEW START------------------- */}

            <div className="xl:hidden block">
              <div className="space-y-2 px-3 border-t-[1px] my-2 py-3">
                <div className="space-y-2">
                  <SingleBookingDetailItem
                    label="Pick Up:"
                    value={bookingDetailsById?.source?.placename}
                  />
                  <SingleBookingDetailItem
                    label="Drop Off:"
                    value={bookingDetailsById?.destination?.placename}
                  />
                </div>
                <div className="flex space-x-2 items-center">
                  <div className="text-sm font-semibold text-gray-600">
                    Vehicle Type:
                  </div>
                  <div className="text-sm text-primary font-semibold">
                    {bookingDetailsById?.vehicleDetails?.type}
                  </div>
                </div>
                <div className="flex space-x-5">
                  <SingleBookingDetailItem
                    label="Distance:"
                    value={
                      Math.round(bookingDetailsById?.travelDistance) + " KM"
                    }
                  />
                  <div className="flex space-x-2 items-center">
                    <div className="text-sm font-semibold text-gray-600">
                      Price:
                    </div>
                    <div className="text-sm text-secondary font-semibold">
                      {bookingDetailsById?.priceDetails?.currency}&nbsp;
                      {Math.round(bookingDetailsById?.priceDetails?.amount)}
                    </div>

                    {editItemCount["amount"] === true && (
                      <>
                        <div className="text-xs italic text-emerald-700 font-semibold">
                          Edited
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <SingleBookingDetailItem
                  label="Special Request:"
                  value={bookingDetailsById?.passengerDetails?.specialRequest}
                />
              </div>

              <div className="">
                <h2 className="grow text-md font-semibold border-b-2 bg-slate-200 px-3  text-secondary uppercase py-1">
                  Booking Details
                </h2>
                <div className="px-3 py-2.5 space-y-2">
                  <div className="space-y-2">
                    <SingleBookingDetailItem
                      label="Booking Id:"
                      value={bookingDetailsById?.bookingId}
                    />
                    <SingleBookingDetailItem
                      label="Created Date:"
                      value={moment(bookingDetailsById?.createdAt).format(
                        "DD-MM-YYYY"
                      )}
                    />
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="text-sm font-semibold text-gray-700">
                      Payment Status:
                    </div>
                    <div
                      className={`${
                        bookingDetailsById?.paymentStatus === "UNPAID"
                          ? "text-red-600"
                          : bookingDetailsById?.paymentStatus === "PAID" &&
                            "text-green-600"
                      }  text-sm font-semibold`}
                    >
                      {bookingDetailsById?.paymentStatus}
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="text-sm font-semibold text-gray-700">
                      Booking Status:
                    </div>
                    <div>
                      <div
                        className={`${
                          bookingDetailsById?.bookingStatus === "CANCELLED"
                            ? "text-red-700"
                            : bookingDetailsById?.bookingStatus === "COMPLETED"
                            ? "text-yellow-600"
                            : bookingDetailsById?.bookingStatus === "CONFIRMED"
                            ? "text-green-600"
                            : bookingDetailsById?.bookingStatus === "POB"
                            ? "text-blue-600"
                            : bookingDetailsById?.bookingStatus === "NOSHOW"
                            ? "text-orange-600"
                            : "text-gray-700"
                        }  text-sm font-semibold`}
                      >
                        {bookingDetailsById?.bookingStatus}
                      </div>
                      x
                      {/* <div className="bg-teal-700 rounde-sm ">
                        Confirm Booking
                      </div> */}
                    </div>
                  </div>
                  <div>
                    <SingleBookingDetailItem
                      label="Reference Number:"
                      value={
                        bookingDetailsById?.passengerDetails?.referenceNumber
                      }
                    />
                    {bookingDetailsById?.cancellationFee > 0 && (
                      <SingleBookingDetailItem
                        label="Cancellation Fee:"
                        value={bookingDetailsById?.cancellationFee}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="">
                <h2 className="grow text-md font-semibold border-b-2 bg-slate-200 px-3  text-secondary uppercase py-1">
                  Passenger Details
                </h2>
                <div className="px-3 py-2.5 space-y-2">
                  <div className="flex space-x-1">
                    <SingleBookingDetailItem
                      label="Passenger Name:"
                      value={
                        bookingDetailsById?.passengerDetails?.firstName +
                        " " +
                        bookingDetailsById?.passengerDetails?.lastName
                      }
                    />

                    {(editItemCount["firstName"] === true ||
                      editItemCount["lastName"] === true) && (
                      <>
                        <div className="text-xs italic text-emerald-700 font-semibold">
                          Edited
                        </div>
                      </>
                    )}
                  </div>
                  <div className="flex space-x-1">
                    <SingleBookingDetailItem
                      label="Mobile Number:"
                      value={
                        bookingDetailsById?.passengerDetails?.code +
                        " " +
                        bookingDetailsById?.passengerDetails?.phone
                      }
                    />

                    {editItemCount["phone"] === true && (
                      <div className="text-xs italic text-emerald-700 font-semibold">
                        Edited
                      </div>
                    )}
                  </div>
                  <div className="space-y-2">
                    <SingleBookingDetailItem
                      label="Email:"
                      value={bookingDetailsById?.passengerDetails?.email}
                    />
                    <SingleBookingDetailItem
                      label="Number of Passenger:"
                      value={bookingDetailsById?.passenger}
                    />
                  </div>
                </div>
              </div>

              <div className="">
                <h2 className="grow text-md font-semibold border-b-2 bg-slate-200 px-3  text-secondary uppercase py-1">
                  Affilate Details
                </h2>
                <div className="px-3 py-2.5 space-y-2">
                  <SingleBookingDetailItem
                    label="Affiliate To:"
                    value={bookingDetailsById?.affiliateDetails?.affiliateName}
                  />
                  <SingleBookingDetailItem
                    label="Affiliate At:"
                    value={
                      bookingDetailsById?.afiliateAssignedAt &&
                      moment(bookingDetailsById?.afiliateAssignedAt).format(
                        "DD-MM-YYYY | hh:mm A"
                      )
                    }
                  />
                  <SingleBookingDetailItem
                    label="Assigned By:"
                    value={bookingDetailsById?.afiliateAssignedBy}
                  />
                  <SingleBookingDetailItem
                    label="Contact Affiliate:"
                    value={bookingDetailsById?.affiliateDetails?.phone1}
                  />
                  <SingleBookingDetailItem
                    label="Purchase Price:"
                    value={
                      bookingDetailsById?.purchaseCurrency &&
                      bookingDetailsById?.purchasePrice &&
                      bookingDetailsById?.purchaseCurrency +
                        " " +
                        bookingDetailsById?.purchasePrice
                    }
                  />
                  <div className="flex space-x-3">
                    <SingleBookingDetailItem
                      label="Affiliate Note:"
                      value={bookingDetailsById?.affiliateNote}
                    />
                  </div>
                  <div className="space-y-3 pt-0.5">
                    <SingleBookingDetailItem
                      label="Driver Name:"
                      value={bookingDetailsById?.driverDetails?.name}
                    />
                    <SingleBookingDetailItem
                      label="Contact Number:"
                      value={bookingDetailsById?.driverDetails?.contactNumber}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* ------------------------DESKTOP VIEW START------------------- */}
            <div className="hidden xl:block">
              <div className="flex bg-gray-200 rounded-t-md mx-3 mt-3 pl-3 py-1">
                <div className="grow text-lg font-semibold border-b-2  text-primary uppercase pt-1">
                  Booking Details
                </div>
                <div className="grow text-lg font-semibold border-b-2  text-primary uppercase pl-16 pt-1">
                  Passenger Details
                </div>
                {user?.role === "ADMIN" && (
                  <>
                    <div className="grow text-lg font-semibold border-b-2 text-primary uppercase pt-1">
                      Affiliate details
                    </div>
                    {user?.role === "ADMIN" && (
                      <div className=" text-center">
                        <Tooltip title="Send Affiliate Voucher">
                          <IconButton
                            onClick={() => {
                              dispatch({
                                type: "SEND_AFFILIATE_VOUCHER",
                                payload: {
                                  token,
                                  body: {
                                    affiliate_name:
                                      bookingDetailsById?.affiliateDetails
                                        ?.affiliateName,
                                    company_name: companyName,
                                    email:
                                      bookingDetailsById?.affiliateDetails
                                        ?.email1,
                                    email2: bookingDetailsById?.affiliateDetails
                                      ?.email2
                                      ? bookingDetailsById?.affiliateDetails
                                          ?.email2
                                      : "",
                                    booking_id: bookingDetailsById?.bookingId,
                                    from: bookingDetailsById?.source?.placename,
                                    to: bookingDetailsById?.destination
                                      ?.placename,
                                    timeAndDate:
                                      moment(
                                        bookingDetailsById?.travelDate
                                      ).format("DD-MM-YYYY") +
                                      " | " +
                                      bookingDetailsById?.travelTime,
                                    bookingType:
                                      bookingDetailsById?.bookingType
                                        ?.charAt(0)
                                        ?.toUpperCase() +
                                      bookingDetailsById?.bookingType
                                        ?.slice(1)
                                        .toLowerCase(),
                                    bookingStatus:
                                      bookingDetailsById?.bookingStatus,
                                    distance:
                                      bookingDetailsById?.bookingType ===
                                      "HOURLY"
                                        ? `${
                                            bookingDetailsById?.durationForAffiliate
                                              ? bookingDetailsById?.durationForAffiliate
                                              : bookingDetailsById?.duration +
                                                " hours"
                                          }`
                                        : Math.round(
                                            bookingDetailsById?.travelDistance
                                          ) + " KM",
                                    flt_no:
                                      bookingDetailsById?.passengerDetails
                                        ?.flightNumber,
                                    sp_req:
                                      bookingDetailsById?.passengerDetails
                                        ?.specialRequest,
                                    vehicleType:
                                      bookingDetailsById?.vehicleDetails
                                        ?.categoryType,
                                    price:
                                      bookingDetailsById?.purchaseCurrency +
                                      " " +
                                      bookingDetailsById?.purchasePrice,
                                    passengerName:
                                      bookingDetailsById?.passengerDetails
                                        ?.firstName +
                                      " " +
                                      bookingDetailsById?.passengerDetails
                                        ?.lastName,
                                    pax_email:
                                      bookingDetailsById?.passengerDetails
                                        ?.email,
                                    mob_number:
                                      bookingDetailsById?.passengerDetails
                                        ?.code +
                                      " " +
                                      bookingDetailsById?.passengerDetails
                                        ?.phone,
                                    pax: bookingDetailsById?.passenger,
                                    emergency_number:
                                      settings?.emergencyContact1 +
                                      " " +
                                      settings?.emergencyContact2 +
                                      " " +
                                      settings?.emergencyContact3,
                                  },
                                },
                              });
                              dispatch({
                                type: "BOOKING_HISTORY_CREATE",
                                payload: {
                                  body: {
                                    booking: bookingDetailsById?._id,
                                    userName: user?.userName,
                                    updateItem: "Affiliate Voucher sent",
                                  },
                                  token,
                                  bookingId: bookingDetailsById?._id,
                                },
                              });
                            }}
                          >
                            <Send className="" />
                            {/* <div className="text-xs">Send Voucher</div> */}
                          </IconButton>
                        </Tooltip>

                        {/* <CircularProgress className="w-10" /> */}
                      </div>
                    )}
                  </>
                )}
                <div></div>
              </div>
              <div className="px-10 pt-2 shadow-md py-5">
                <div className="flex pb-2">
                  <div className="grow">
                    <div className="space-y-2 pt-3">
                      <SingleBookingDetailItem
                        label="Booking Id:"
                        value={bookingDetailsById?.bookingId}
                        iconname={faArrowRightArrowLeft}
                      />
                      <SingleBookingDetailItem
                        label="Created Date:"
                        value={moment(bookingDetailsById?.createdAt).format(
                          "DD-MM-YYYY"
                        )}
                        iconname={faCheckCircle}
                      />
                      <SingleBookingDetailItem
                        label="Booking Type:"
                        value={
                          bookingDetailsById?.bookingType
                            ?.charAt(0)
                            ?.toUpperCase() +
                          bookingDetailsById?.bookingType
                            ?.slice(1)
                            .toLowerCase()
                        }
                        iconname={faHourglassEnd}
                      />
                      <div className="flex-col">
                        <div className="flex space-x-2">
                          <SingleBookingDetailItem
                            label="Flight No:"
                            value={
                              bookingDetailsById?.passengerDetails?.flightNumber
                            }
                            iconname={faSignsPost}
                          />

                          {bookingDetailsById?.passengerDetails
                            ?.flightNumber && (
                            <div className="flex space-x-1">
                              <div
                                className="py-1 bg-teal-700 hover:bg-teal-600 rounded-full text-xs items-center cursor-pointer px-2 py-0.25 text-white"
                                onClick={showFlightStatus}
                              >
                                <div>Live Flight Status</div>
                              </div>
                              {flightLoading && (
                                <div className="text-xs text-gray-500 italic">
                                  Loading...
                                </div>
                              )}
                            </div>
                          )}

                          {editItemCount["flightNumber"] === true && (
                            <div className="text-xs italic text-teal-700 font-semibold">
                              Edited
                            </div>
                          )}
                        </div>
                        {(flightData?.status === "A" ||
                          flightData?.status === "S" ||
                          flightData?.status === "L") && (
                          <div
                            className={`animate__animated animate__fadeInLeftBig  w-80 mt-2 shadow-md ${
                              flightData?.delays?.arrivalGateDelayMinutes
                                ? "border-red-600 border-1"
                                : "border-gray-300 border-2"
                            } border-gray-300 border-[1px] rounded-md py-0.5 px-2 ml-2 text-xs text-center`}
                          >
                            <div>
                              {flightData?.delays?.arrivalGateDelayMinutes && (
                                <div className="text-red-50 bg-red-600 px-1 py-0.5 rounded-md">
                                  Delayed by{" "}
                                  {flightData?.delays?.arrivalGateDelayMinutes}{" "}
                                  mins
                                </div>
                              )}
                              {!flightData?.delays?.arrivalGateDelayMinutes &&
                                (flightData?.status === "A" ||
                                  flightData?.status === "S") && (
                                  <div className="text-green-50 bg-green-600 px-1 py-0.5 rounded-md">
                                    On Time
                                  </div>
                                )}
                            </div>
                            <div className="flex text-center justify-between space-x-5">
                              <div className="font-semibold text-sm text-[#fb4156]">
                                {flightData?.departureAirportFsCode}{" "}
                              </div>
                              {(flightData?.status === "A" ||
                                flightData?.status === "S") && (
                                <div className="relative">
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faPlane}
                                    className="text-lg mt-1 text-green-500 absolute "
                                  />
                                  <FontAwesomeIcon
                                    icon={faPlane}
                                    className="text-lg mt-1 text-green-500 animate-ping "
                                  />
                                </div>
                              )}
                              {flightData?.status === "L" && (
                                <FontAwesomeIcon
                                  icon={faPlaneArrival}
                                  className="text-lg mt-1 text-green-500"
                                />
                              )}

                              <div className="font-semibold text-sm text-[#fb4156]">
                                {flightData?.arrivalAirportFsCode}{" "}
                              </div>
                            </div>
                            <div className="flex text-center justify-between space-x-5 mt-2">
                              <div>
                                <div>STA</div>
                                <div className="text-sm font-semibold ">
                                  {moment(
                                    flightData?.operationalTimes
                                      ?.publishedArrival?.dateLocal
                                  ).format("DD-MM-YYYY hh:mm A")}
                                </div>
                              </div>
                              {!flightData?.operationalTimes
                                ?.actualGateArrival && (
                                <div>
                                  <div>ETA</div>
                                  {flightData?.operationalTimes
                                    ?.estimatedGateArrival?.dateLocal ? (
                                    <div className="text-sm font-semibold">
                                      {moment(
                                        flightData?.operationalTimes
                                          ?.estimatedGateArrival?.dateLocal
                                      ).format("DD-MM-YYYY h:mm A")}
                                    </div>
                                  ) : (
                                    "--"
                                  )}
                                </div>
                              )}
                              {flightData?.operationalTimes
                                ?.actualGateArrival && (
                                <div>
                                  <div> Actual Arrival Time</div>
                                  <div className="text-sm font-semibold">
                                    {moment(
                                      flightData?.operationalTimes
                                        ?.actualGateArrival?.dateLocal
                                    ).format("DD-MM-YYYY h:mm A")}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="flex text-center justify-between space-x-5 mt-2">
                              <div className="flex items-center space-x-2">
                                <div className="flex items-center space-x-2">
                                  <Airlines className="w-5 h-5 text-slate-600" />{" "}
                                  <div> Arr Terminal No</div>
                                </div>
                                <div className="text-xl font-semibold text-teal-700">
                                  {flightData?.airportResources?.arrivalTerminal
                                    ? flightData?.airportResources
                                        ?.arrivalTerminal
                                    : "--"}
                                </div>
                              </div>
                              <div className="flex items-center space-x-2">
                                <div className="flex items-center space-x-2">
                                  <Luggage className="w-5 h-5 text-slate-600" />{" "}
                                  <div>Belt No</div>
                                </div>
                                <div className="text-xl font-semibold text-teal-700">
                                  {flightData?.airportResources?.baggage
                                    ? flightData?.airportResources?.baggage
                                    : "--"}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {/* PAYMENT STATUS */}
                      <div className="flex space-x-2 items-center">
                        <FontAwesomeIcon
                          icon={faSignsPost}
                          className="text-gray-400 w-5"
                        />
                        <div className="text-sm font-semibold text-gray-700">
                          Payment Status:
                        </div>
                        <div
                          className={`${
                            bookingDetailsById?.paymentStatus === "UNPAID"
                              ? "text-red-600"
                              : bookingDetailsById?.paymentStatus === "PAID" &&
                                "text-green-600"
                          }  text-sm font-semibold`}
                        >
                          {bookingDetailsById?.paymentStatus}
                        </div>
                      </div>

                      <div className="flex space-x-2 items-center">
                        <FontAwesomeIcon
                          icon={faSignsPost}
                          className="text-gray-400 w-5"
                        />
                        <div className="text-sm font-semibold text-gray-700">
                          Booking Status:
                        </div>
                        <div
                          className={`${
                            bookingDetailsById?.bookingStatus === "CANCELLED"
                              ? "text-red-700"
                              : bookingDetailsById?.bookingStatus ===
                                "COMPLETED"
                              ? "text-yellow-600"
                              : bookingDetailsById?.bookingStatus ===
                                "CONFIRMED"
                              ? "text-green-600"
                              : bookingDetailsById?.bookingStatus === "POB"
                              ? "text-blue-600"
                              : bookingDetailsById?.bookingStatus === "NOSHOW"
                              ? "text-orange-600"
                              : "text-gray-700"
                          }  text-sm font-semibold`}
                        >
                          {bookingDetailsById?.bookingStatus === "ONREQUEST" &&
                            bookingDetailsById?.bookingStatus.slice(0, 2) +
                              " " +
                              bookingDetailsById?.bookingStatus.slice(2)}

                          {bookingDetailsById?.bookingStatus !== "ONREQUEST" &&
                            bookingDetailsById?.bookingStatus}
                        </div>
                        {(bookingDetailsById?.bookingStatus === "CONFIRMED" ||
                          bookingDetailsById?.bookingStatus === "POB") && (
                          <>
                            {user?.role === "ADMIN" && (
                              <div>
                                <FontAwesomeIcon icon={faArrowRight} />
                              </div>
                            )}
                            {isBookingCompleteStatus && (
                              <div className="z-10 absolute bg-white/95 rounded-md  w-1/3 border-black/20 border h-20 shadow-md px-10 ">
                                <div className="text-sm pt-1 ">
                                  Are you sure you want to change booking status
                                  to{" "}
                                  <span className="text-yellow-600">
                                    COMPLETED ?
                                  </span>
                                </div>
                                <div className="space-x-4 flex justify-end">
                                  <span
                                    onClick={() => {
                                      setisBookingCompleteStatus(
                                        !isBookingCompleteStatus
                                      );
                                    }}
                                    className="border cursor-pointer border-red-700 text-red-700 px-1.5 py-0.25 rounded-md"
                                  >
                                    No
                                  </span>
                                  <span
                                    onClick={() => {
                                      dispatch({
                                        type: "UPDATE_BOOKING",
                                        payload: {
                                          body: {
                                            bookingId:
                                              bookingDetailsById?.bookingId,
                                            bookingStatus: "COMPLETED",
                                          },
                                          token,
                                        },
                                      });
                                      setisBookingCompleteStatus(
                                        !isBookingCompleteStatus
                                      );
                                    }}
                                    className="border cursor-pointer bg-teal-700 text-white border-teal-700  px-1.5 py-0.25 rounded-md"
                                  >
                                    Yes
                                  </span>
                                </div>
                              </div>
                            )}{" "}
                            {/* NO SHOW DILOG BOX */}
                            {openPob && (
                              <div className="z-10 absolute bg-white/95 rounded-md  w-1/3 border-black/20 border h-20 shadow-md px-10 ">
                                <div className="text-sm pt-1 ">
                                  Are you sure you want to change booking status
                                  to{" "}
                                  <span className="text-yellow-600">POB ?</span>
                                </div>
                                <div className="space-x-4 flex justify-end">
                                  <span
                                    onClick={() => {
                                      setopenPob(false);
                                    }}
                                    className="border cursor-pointer border-red-700 text-red-700 px-1.5 py-0.25 rounded-md"
                                  >
                                    No
                                  </span>
                                  <span
                                    onClick={() => {
                                      dispatch({
                                        type: "UPDATE_BOOKING",
                                        payload: {
                                          body: {
                                            bookingId:
                                              bookingDetailsById?.bookingId,
                                            bookingStatus: "POB",
                                          },
                                          token,
                                        },
                                      });
                                      setopenPob(false);
                                    }}
                                    className="border cursor-pointer bg-teal-700 text-white border-teal-700  px-1.5 py-0.25 rounded-md"
                                  >
                                    Yes
                                  </span>
                                </div>
                              </div>
                            )}
                            {isBookingNoShowStatus && (
                              <div className="z-10 absolute bg-white/95 rounded-md  w-1/3 border-black/20 border h-20 shadow-md px-10 ">
                                <div className="text-sm pt-1 ">
                                  Are you sure you want to change booking status
                                  to{" "}
                                  <span className="text-yellow-600">
                                    NO SHOW ?
                                  </span>
                                </div>
                                <div className="space-x-4 flex justify-end">
                                  <span
                                    onClick={() => {
                                      setisBookingNoShowStatus(
                                        !isBookingNoShowStatus
                                      );
                                    }}
                                    className="border cursor-pointer border-red-700 text-red-700 px-1.5 py-0.25 rounded-md"
                                  >
                                    No
                                  </span>
                                  <span
                                    onClick={() => {
                                      dispatch({
                                        type: "UPDATE_BOOKING",
                                        payload: {
                                          body: {
                                            bookingId:
                                              bookingDetailsById?.bookingId,
                                            bookingStatus: "NOSHOW",
                                          },
                                          token,
                                        },
                                      });
                                      setisBookingNoShowStatus(
                                        !isBookingNoShowStatus
                                      );
                                    }}
                                    className="border cursor-pointer bg-teal-700 text-white border-teal-700  px-1.5 py-0.25 rounded-md"
                                  >
                                    Yes
                                  </span>
                                </div>
                              </div>
                            )}{" "}
                            {user?.role === "ADMIN" && (
                              <div
                                onClick={() => {
                                  setisBookingCompleteStatus(
                                    !isBookingNoShowStatus
                                  );
                                }}
                                className="text-xs bg-teal-600 hover:bg-teal-700 hover:animate-pulse px-1.5 py-1 rounded-full text-white cursor-pointer"
                              >
                                C
                              </div>
                            )}
                            {user?.role === "ADMIN" && (
                              <div
                                onClick={() => {
                                  setisBookingNoShowStatus(
                                    !isBookingNoShowStatus
                                  );
                                }}
                                className="text-xs bg-yellow-500 hover:bg-Yellow-700 hover:animate-pulse px-1.5 py-1 rounded-full text-white cursor-pointer"
                              >
                                NS
                              </div>
                            )}
                            {user?.role === "ADMIN" &&
                              bookingDetailsById?.bookingStatus !== "POB" && (
                                <div
                                  onClick={() => {
                                    setopenPob(true);
                                  }}
                                  className="text-xs bg-sky-700 hover:bg-Yellow-700 hover:animate-pulse px-1.5 py-1 rounded-full text-white cursor-pointer"
                                >
                                  POB
                                </div>
                              )}
                            {user?.role === "ADMIN" &&
                              bookingDetailsById?.bookingStatus === "POB" && (
                                <div>
                                  <span class="relative flex h-3 w-3">
                                    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-50"></span>
                                    <span class="relative inline-flex rounded-full h-3 w-3 bg-teal-400"></span>
                                  </span>
                                </div>
                              )}
                          </>
                        )}
                        {user?.role !== "ADMIN" &&
                          bookingDetailsById?.bookingStatus === "ONREQUEST" &&
                          user?.permission?.manageBooking?.approveBooking
                            ?.permission === "ENABLE" && (
                            <div
                              onClick={async () => {
                                dispatch({
                                  type: "GET_TIME_DETAILS",
                                  payload: {
                                    lat: bookingDetailsById?.source?.lat,
                                    lng: bookingDetailsById?.source?.lng,
                                  },
                                });

                                if (user?.company?.availableLimit <= 0) {
                                  toast.error(
                                    "Insufficient credit limit. Please contact us at support@drivado.com"
                                  );
                                } else if (user?.company?.availableLimit > 0) {
                                  toast.loading("Updating booking status...");
                                  let resamount = await axios.get(
                                    `${
                                      process.env.REACT_APP_BASE_URL
                                    }/bookings/currencyLayer?from=${
                                      bookingDetailsById?.priceDetails.currency
                                    }&to=USD&amount=${Math.round(
                                      bookingDetailsById?.priceDetails.amount
                                    )}`,
                                    {
                                      withCredentials: true,
                                    }
                                  );

                                  let totalUnpaidBooking =
                                    bookingDetailsById?.user?.unpaidBooking +
                                    bookingDetailsById?.bookingPriceInUsd;

                                  let totalUnpaidBookingCompany =
                                    bookingDetailsById?.user?.company
                                      ?.totalUnpaidBooking +
                                    bookingDetailsById?.bookingPriceInUsd;

                                  let availableLimitCompany =
                                    bookingDetailsById?.user?.company
                                      ?.availableLimit -
                                    bookingDetailsById?.bookingPriceInUsd;

                                  dispatch({
                                    type: "UPDATE_BOOKING",
                                    payload: {
                                      body: {
                                        bookingId:
                                          bookingDetailsById?.bookingId,
                                        bookingStatus: "CONFIRMED",
                                      },
                                      token,
                                    },
                                  });

                                  dispatch({
                                    type: "EDIT_USER",
                                    payload: {
                                      userId: bookingDetailsById?.user._id,
                                      body: {
                                        unpaidBooking: totalUnpaidBooking,
                                      },
                                      token,
                                    },
                                  });
                                  dispatch({
                                    type: "EDIT_COMPANY",
                                    payload: {
                                      companyId:
                                        bookingDetailsById?.user?.company?._id,
                                      body: {
                                        totalUnpaidBooking:
                                          totalUnpaidBookingCompany,
                                        availableLimit: availableLimitCompany,
                                      },
                                      token,
                                    },
                                  });
                                }
                              }}
                              className="bg-teal-700 hover:bg-teal-600 cursor-pointer  rounded-full text-xs text-white px-1.5 py-1"
                            >
                              Confirm
                            </div>
                          )}
                        {user?.role !== "ADMIN" &&
                          bookingDetailsById?.bookingStatus === "ONREQUEST" &&
                          user?.permission?.manageBooking?.cancelRequestBooking
                            ?.permission === "ENABLE" && (
                            <div
                              onClick={async () => {
                                if (user?.company?.availableLimit < 0) {
                                  toast.error("Your company limit is over");
                                } else {
                                  toast.loading("Updating booking status...");

                                  dispatch({
                                    type: "UPDATE_BOOKING",
                                    payload: {
                                      body: {
                                        bookingId:
                                          bookingDetailsById?.bookingId,
                                        bookingStatus: "CANCELLED",
                                      },
                                      token,
                                    },
                                  });

                                  toast.dismiss();
                                }
                              }}
                              className="bg-red-700 hover:bg-red-600 cursor-pointer  rounded-full text-xs text-white px-1.5 py-1"
                            >
                              Reject
                            </div>
                          )}
                        {Math.floor(timeDiffInSeconds / 3600) <
                          settings?.bookingTimeFrame && (
                          // {true && (
                          <>
                            <div className="absolute transform translate-x-[100px] animate p-3 rounded-md text-secondary font-semibold">
                              {user.role === "USER" && (
                                <span>
                                  Time must be at least{" "}
                                  {settings?.bookingTimeFrame} hours from pick
                                  up time
                                </span>
                              )}
                            </div>
                          </>
                        )}

                        {/* ADMIN  */}
                        {user?.role === "ADMIN" &&
                          bookingDetailsById?.bookingStatus === "ONREQUEST" && (
                            <div
                              onClick={async () => {
                                // dispatch({
                                //   type: "GET_TIME_DETAILS",
                                //   payload:
                                //     bookingDetailsById?.source.lat +
                                //     "," +
                                //     bookingDetailsById?.source?.lng,
                                // });

                                let resamount = await axios.get(
                                  `${
                                    process.env.REACT_APP_BASE_URL
                                  }/bookings/currencyLayer?from=${
                                    bookingDetailsById?.priceDetails.currency
                                  }&to=USD&amount=${Math.round(
                                    bookingDetailsById?.priceDetails.amount
                                  )}`,
                                  {
                                    withCredentials: true,
                                  }
                                );

                                let totalUnpaidBooking =
                                  bookingDetailsById?.user?.unpaidBooking +
                                  bookingDetailsById?.bookingPriceInUsd;

                                let totalUnpaidBookingCompany =
                                  bookingDetailsById?.user?.company
                                    ?.totalUnpaidBooking +
                                  bookingDetailsById?.bookingPriceInUsd;

                                let availableLimitCompany =
                                  bookingDetailsById?.user?.company
                                    ?.availableLimit -
                                  bookingDetailsById?.bookingPriceInUsd;

                                dispatch({
                                  type: "UPDATE_BOOKING",
                                  payload: {
                                    body: {
                                      bookingId: bookingDetailsById?.bookingId,
                                      bookingStatus: "CONFIRMED",
                                    },
                                    token,
                                  },
                                });

                                dispatch({
                                  type: "EDIT_USER",
                                  payload: {
                                    userId: bookingDetailsById?.user._id,
                                    body: {
                                      unpaidBooking: totalUnpaidBooking,
                                    },
                                    token,
                                  },
                                });
                                dispatch({
                                  type: "EDIT_COMPANY",
                                  payload: {
                                    companyId:
                                      bookingDetailsById?.user?.company?._id,
                                    body: {
                                      totalUnpaidBooking:
                                        totalUnpaidBookingCompany,
                                      availableLimit: availableLimitCompany,
                                    },
                                    token,
                                  },
                                });
                                // navigate(
                                //   "/newbooking/searchResult/passengerDetail/bookingSummary/bookingStatus"
                                // );
                              }}
                              className="bg-teal-700 hover:bg-teal-600 cursor-pointer  rounded-full text-xs text-white px-1.5 py-1"
                            >
                              Confirm
                            </div>
                          )}
                        {user?.role === "ADMIN" &&
                          bookingDetailsById?.bookingStatus === "ONREQUEST" && (
                            <div
                              onClick={async () => {
                                dispatch({
                                  type: "UPDATE_BOOKING",
                                  payload: {
                                    body: {
                                      bookingId: bookingDetailsById?.bookingId,
                                      bookingStatus: "CANCELLED",
                                    },
                                    token,
                                  },
                                });
                              }}
                              className="bg-red-700 hover:bg-red-600 cursor-pointer  rounded-full text-xs text-white px-1.5 py-1"
                            >
                              Reject
                            </div>
                          )}
                      </div>

                      {/* <SingleBookingDetailItem
                        label="Reference Number:"
                        value={
                          bookingDetailsById?.passengerDetails?.referenceNumber
                        }
                        iconname={faHashtag}
                      /> */}
                      <div className="flex space-x-2 items-center">
                        <FontAwesomeIcon
                          icon={faHashtag}
                          className="text-gray-400 w-5"
                        />
                        <div className="text-sm font-semibold text-gray-700">
                          Reference Number:{" "}
                        </div>
                        {singleBookingDetailLoading ? (
                          <>
                            <Skeleton animation="wave" width={200} />
                          </>
                        ) : (
                          <>
                            <Tooltip
                              title={
                                bookingDetailsById?.passengerDetails
                                  ?.referenceNumber
                              }
                            >
                              <div className="text-sm truncate w-32">
                                {
                                  bookingDetailsById?.passengerDetails
                                    ?.referenceNumber
                                }
                              </div>
                            </Tooltip>
                            {bookingDetailsById?.passengerDetails
                              ?.referenceNumber ? (
                              <>
                                <span
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      bookingDetailsById?.passengerDetails
                                        ?.referenceNumber
                                    );
                                    setcopyMsg(true);
                                    setTimeout(() => {
                                      setcopyMsg(false);
                                    }, 1000);
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faCopy}
                                    className="w-3 cursor-pointer text-gray-700 pl-1.5"
                                  />
                                </span>
                              </>
                            ) : null}
                            {copyMsg && (
                              <div className="text-xs italic text-gray-500 animate__animated animate__fadeIn absolute translate-x-[22rem]">
                                Reference Number Copied
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      {bookingDetailsById?.cancellationFee > 0 && (
                        <SingleBookingDetailItem
                          label="Cancellation Fee:"
                          value={bookingDetailsById?.cancellationFee}
                          iconname={faHashtag}
                        />
                      )}
                    </div>
                  </div>
                  <div className="grow">
                    <div className="space-y-3 pt-3 border-primary ">
                      <div className="flex space-x-1">
                        <SingleBookingDetailItem
                          label="Passenger Name:"
                          value={
                            bookingDetailsById?.passengerDetails?.firstName +
                            " " +
                            bookingDetailsById?.passengerDetails?.lastName
                          }
                          iconname={faUser}
                        />

                        {(editItemCount["firstName"] === true ||
                          editItemCount["lastName"] === true) && (
                          <>
                            <div className="text-xs italic text-emerald-700 font-semibold">
                              Edited
                            </div>
                          </>
                        )}
                      </div>
                      <div className="flex space-x-1">
                        <SingleBookingDetailItem
                          label="Mobile Number:"
                          value={
                            bookingDetailsById?.passengerDetails?.code +
                            " " +
                            bookingDetailsById?.passengerDetails?.phone
                          }
                          iconname={faMobile}
                        />

                        {editItemCount["phone"] === true && (
                          <div className="text-xs italic text-emerald-700 font-semibold">
                            Edited
                          </div>
                        )}
                      </div>
                      <SingleBookingDetailItem
                        label="Email:"
                        value={bookingDetailsById?.passengerDetails?.email}
                        iconname={faEnvelope}
                      />
                      <SingleBookingDetailItem
                        label="Number of Passenger:"
                        value={bookingDetailsById?.passenger}
                        iconname={faUsers}
                      />
                    </div>
                  </div>

                  <div className="grow">
                    <div className="flex justify-between pt-3">
                      <div className="space-y-2 relative">
                        {user?.role === "ADMIN" && (
                          <div className="flex space-x-3">
                            <SingleBookingDetailItem
                              label="Affiliate To:"
                              value={
                                bookingDetailsById?.affiliateDetails
                                  ?.affiliateName
                              }
                              iconname={faUser}
                            />
                            {bookingDetailsById?.affiliateDetails
                              ?.affiliateName &&
                            !bookingDetailsById?.affiliatePayment ? (
                              <img
                                src={alertCreditCard}
                                alt="alert creditcard "
                                className="w-10 cursor-pointer"
                                onClick={() => {
                                  setaffiliatePaymentModalOpen(
                                    !affiliatePaymentModalOpen
                                  );
                                }}
                              />
                            ) : (
                              bookingDetailsById?.affiliateDetails
                                ?.affiliateName && (
                                <CreditCardIcon className="w-8 h-8 text-green-700 " />
                              )
                            )}
                            <div className="text-sm text-gray-400">
                              {bookingDetailsById?.affiliatePayment}
                            </div>
                          </div>
                        )}

                        {affiliatePaymentModalOpen && (
                          <div className="z-10 absolute bg-white rounded-md  w-1/2 border-black/20 border h-32 shadow-md px-3 ">
                            <div className="text-base pt-1 ">
                              Pay by <br />
                              <div className="flex space-x-2 pt-2">
                                <input
                                  type="radio"
                                  id="html"
                                  name="fav_language"
                                  value="PBI"
                                  onClick={() => {
                                    setaffiliatepaymentStatus("PBI");
                                  }}
                                />
                                <label for="html" className="cursor-pointer">
                                  PBI
                                </label>
                                <input
                                  type="radio"
                                  id="css"
                                  name="fav_language"
                                  value="PRP"
                                  onClick={() => {
                                    setaffiliatepaymentStatus("PRP");
                                  }}
                                />
                                <label for="css" className="cursor-pointer">
                                  PRP
                                </label>
                              </div>
                            </div>
                            <div className="space-x-4 flex justify-center pt-4">
                              <span
                                onClick={() => {
                                  setaffiliatePaymentModalOpen(false);
                                }}
                                className="border cursor-pointer text-sm border-red-700 text-red-700 px-1.5 py-0.25 rounded-md"
                              >
                                Close
                              </span>
                              <span
                                onClick={() => {
                                  affiliatePaymentStatus();
                                  setaffiliatePaymentModalOpen(
                                    !affiliatePaymentModalOpen
                                  );
                                }}
                                className="border cursor-pointer bg-teal-700 text-white border-teal-700  px-1.5 text-sm rounded-md"
                              >
                                Save
                              </span>
                            </div>
                          </div>
                        )}

                        {user?.role === "ADMIN" && (
                          <SingleBookingDetailItem
                            label="Affiliate At:"
                            value={
                              bookingDetailsById?.afiliateAssignedAt &&
                              moment(
                                bookingDetailsById?.afiliateAssignedAt
                              ).format("DD-MM-YYYY | hh:mm A")
                            }
                            iconname={faLocationDot}
                          />
                        )}
                        {user?.role === "ADMIN" && (
                          <SingleBookingDetailItem
                            label="Assigned By:"
                            value={bookingDetailsById?.afiliateAssignedBy}
                            iconname={faArrowRightArrowLeft}
                          />
                        )}
                        {user?.role === "ADMIN" && (
                          <SingleBookingDetailItem
                            label="Contact Affiliate:"
                            value={
                              (bookingDetailsById?.affiliateDetails
                                ?.countryCode !== undefined
                                ? bookingDetailsById?.affiliateDetails
                                    ?.countryCode
                                : "") +
                              " " +
                              (bookingDetailsById?.affiliateDetails?.phone1 !==
                              undefined
                                ? bookingDetailsById?.affiliateDetails?.phone1
                                : "")
                            }
                            iconname={faCheckCircle}
                          />
                        )}
                        {user?.role === "ADMIN" && (
                          <div className=" flex space-x-2">
                            <SingleBookingDetailItem
                              label="Purchase Price:"
                              value={
                                bookingDetailsById?.purchaseCurrency &&
                                bookingDetailsById?.purchasePrice &&
                                bookingDetailsById?.purchaseCurrency +
                                  " " +
                                  bookingDetailsById?.purchasePrice
                              }
                              iconname={faCheckCircle}
                            />
                            {/* MARK EDITED WHEN purchasePrice is edited and purchaseCurrency is edited */}
                            {(editItemCount["purchasePrice"] === true ||
                              editItemCount["purchaseCurrency"] === true) && (
                              <>
                                <div className="text-xs italic text-emerald-700 font-semibold">
                                  Edited
                                </div>
                              </>
                            )}
                          </div>
                        )}
                        {user?.role === "ADMIN" && (
                          <div className="flex space-x-3">
                            <SingleBookingDetailItem
                              label="Affiliate Note:"
                              value={bookingDetailsById?.affiliateNote}
                              iconname={faCheckCircle}
                            />
                          </div>
                        )}
                        {/* <div className="flex space-x-2 items-center">
                          <FontAwesomeIcon
                            icon={faCreditCard}
                            className="text-gray-400 w-5"
                          />
                          <div className="text-sm font-semibold text-gray-700">
                            Credit Cards{" "}
                          </div>
                          <div>
                            {bookingDetailsById?.creditCards?.map((card) => (
                              <>
                                <div className="flex items-center space-x-5">
                                  <div className="text-sm flex space-x-1 font-medium">
                                    <span className="text-blue-700">
                                      {card?.name}
                                    </span>
                                    <span className="space-x-2">
                                      {card?.bank}
                                    </span>
                                    <span className="font-semibold space-x-1 text-green-700">
                                      {card?.cardNumberLastFour}
                                    </span>
                                  </div>
                                  <div className="flex space-x-2">
                                    <div className="text-secondary">
                                      {card?.currency}
                                    </div>
                                    <div className="font-semibold space-x-1 text-green-700">
                                      {card?.amount}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ))}
                          </div>
                        </div> */}
                        <div className="space-y-3 pt-0.5">
                          <SingleBookingDetailItem
                            label="Driver Name:"
                            value={bookingDetailsById?.driverDetails?.name}
                            iconname={faCheckCircle}
                          />
                          <SingleBookingDetailItem
                            label="Contact Driver:"
                            value={
                              (bookingDetailsById?.driverDetails
                                ?.countryCode !== undefined
                                ? bookingDetailsById?.driverDetails?.countryCode
                                : "") +
                              " " +
                              (bookingDetailsById?.driverDetails
                                ?.contactNumber !== undefined
                                ? bookingDetailsById?.driverDetails
                                    ?.contactNumber
                                : "")
                            }
                            iconname={faCheckCircle}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex">
                  <div className="grow first-letter:space-y-3">
                    <div className="text-xl font-semibold pt-5 text-primary uppercase">
                      Pick Up & Drop Off Details
                    </div>
                    <div className="pt-2">
                      <div className="space-y-2">
                        <SingleBookingDetailItem
                          label="Pick Up:"
                          value={`${bookingDetailsById?.source?.placename} (lat - ${bookingDetailsById?.source?.lat},lng - ${bookingDetailsById?.source?.lng} )`}
                          iconname={faLocationDot}
                        />
                        <SingleBookingDetailItem
                          label="Drop Off:"
                          value={`${bookingDetailsById?.destination?.placename} (lat - ${bookingDetailsById?.destination?.lat},lng - ${bookingDetailsById?.destination?.lng} )`}
                          iconname={faLocationDot}
                        />
                        <div className="flex space-x-1">
                          <SingleBookingDetailItem
                            label="PickUp Date | Time:"
                            value={
                              bookingDetailsById?.travelDate
                                ? moment(
                                    bookingDetailsById?.travelDate?.split(
                                      "T"
                                    )[0]
                                  ).format("DD-MM-YYYY") +
                                  " | " +
                                  bookingDetailsById?.travelTime
                                : ""
                            }
                            iconname={faCalendar}
                          />
                          {editItemCount["travelTime"] === true && (
                            <>
                              <div className="text-xs italic text-emerald-700 font-semibold">
                                Edited
                              </div>
                            </>
                          )}{" "}
                          {editItemCount["travelDate"] === true && (
                            <>
                              <div className="text-xs italic text-emerald-700 font-semibold">
                                Edited
                              </div>
                            </>
                          )}
                        </div>
                        {bookingDetailsById?.bookingType !== "HOURLY" && (
                          <SingleBookingDetailItem
                            label="Distance:"
                            value={
                              Math.round(bookingDetailsById?.travelDistance) +
                              " KM"
                            }
                            iconname={faSignsPost}
                          />
                        )}
                        <SingleBookingDetailItem
                          label="Duration:"
                          value={bookingDetailsById?.duration}
                          iconname={faSignsPost}
                        />
                        {user?.role === "ADMIN" &&
                          bookingDetailsById?.durationForAffiliate !== "" && (
                            <SingleBookingDetailItem
                              label="Duration for affiliate:"
                              value={
                                bookingDetailsById?.durationForAffiliate +
                                " hours"
                              }
                              iconname={faSignsPost}
                            />
                          )}
                        <SingleBookingDetailItem
                          label="Special Request:"
                          value={
                            bookingDetailsById?.passengerDetails?.specialRequest
                          }
                          iconname={faUserCheck}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="pt-16">
                    <div className="ml-2">
                      <div className=" ">
                        <img
                          src={
                            bookingDetailsById?.vehicleDetails?.vehicleImage
                              ?.secure_url
                          }
                          alt=""
                          className="w-1/3 "
                        />

                        <a
                          className="w-min bg-teal-600 h-5 text-center px-3  flex text-sm text-white font-body rounded-full hover:bg-teal-700 shadow-sm"
                          // href={`/traking/${bookingDetailsById?.bookingId}`}
                          href={`https://trkk.netlify.app/${bookingDetailsById?.bookingId}/${bookingDetailsById?.driverDetails?._id}`}
                          target="_"
                        >
                          View&nbsp;Tracking
                        </a>
                      </div>
                      <div className="flex space-x-2 items-center">
                        <div className="text-sm font-semibold text-gray-600">
                          Vehicle Type:
                        </div>
                        <div className="flex space-x-1 items-center text-sm text-primary font-semibold">
                          <div>
                            {bookingDetailsById?.vehicleDetails?.categoryType}{" "}
                          </div>
                          {user?.role === "ADMIN" && (
                            <div className="italic text-xs">
                              {bookingDetailsById?.vehicleDetails?.vehicleName}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <FontAwesomeIcon
                          icon={faMoneyBill}
                          className="w-4 text-gray-500"
                        />
                        <div className="flex space-x-2 items-center">
                          <div className="text-sm font-semibold text-gray-600">
                            Price:
                          </div>
                          <div className="flex space-x-1 items-end">
                            <div className="text-xl text-secondary font-semibold">
                              {bookingDetailsById?.priceDetails?.currency}&nbsp;
                              {Math.round(
                                bookingDetailsById?.priceDetails?.amount
                              )}
                            </div>
                            {bookingDetailsById?.extraPay && <span>+</span>}
                            {bookingDetailsById?.extraPay && (
                              <div className="text-sm text-gray-600 font-normal flex space-x-1 items-center">
                                <span>
                                  {bookingDetailsById?.extraPay} (Extra)
                                </span>
                                <div className="font-semibold text-base">
                                  = {bookingDetailsById?.priceDetails?.currency}{" "}
                                  {bookingDetailsById?.totalPayment}
                                </div>{" "}
                                <span>
                                  / {bookingDetailsById?.extraHour} hours
                                </span>
                              </div>
                            )}
                          </div>

                          {editItemCount["amount"] === true && (
                            <>
                              <div className="text-xs italic text-emerald-700 font-semibold">
                                Edited
                              </div>
                            </>
                          )}
                          {editItemCount["currency"] === true && (
                            <>
                              <div className="text-xs italic text-emerald-700 font-semibold">
                                Edited
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {bookingDetailsById?.paymentType && (
                        <div className="flex items-center space-x-2">
                          <FontAwesomeIcon
                            icon={faMoneyBill}
                            className="w-4 text-gray-500"
                          />
                          <div className="flex space-x-2 items-center">
                            <div className="font-semibold text-gray-600 w-32">
                              Payment Mode:
                            </div>
                            <div className="text-sm font-semibold">
                              {bookingDetailsById?.paymentType}
                            </div>
                          </div>
                        </div>
                      )}

                      {bookingDetailsById?.receivable_note && (
                        <div className="flex items-center space-x-2 py-2">
                          <FontAwesomeIcon
                            icon={faMoneyBill}
                            className="w-4 text-gray-500"
                          />
                          <div className="flex space-x-2 items-center">
                            <div className="font-semibold text-gray-600 w-32">
                              Receivable&nbsp;Note&nbsp;:
                            </div>
                            <div className="text-sm font-semibold">
                              {bookingDetailsById?.receivable_note}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openHistory && (
        <div
          className="bg-black w-screen h-screen absolute opacity-30"
          onClick={() => {
            setopenHistory(false);
          }}
        ></div>
      )}
      {openHistory && (
        <div className="w-72 h-full  absolute  right-0 bg-gray-100 overflow-y-auto">
          <div className="justify-center  flex pt-5 border-b border-gray-500 text-base  ">
            History
          </div>
          <div className="overflow-y-auto scrollbar-hide">
            {bookingDetailsById?.history?.map((item, index) => (
              <>
                <div className="m-3 rounded-md bg-white py-2 px-2 space-y-2 shadow-lg ">
                  <div className="flex space-x-1 items-center">
                    <div className="text-xs text-gray-500">Edit By </div>
                    <div className="text-xs font-semibold">
                      {item?.userName}
                    </div>
                  </div>
                  <div className="flex space-x-1 items-center">
                    <div className="text-xs text-gray-500 ">Edit Item </div>
                    <div className="text-xs font-semibold">
                      {item?.updateItem}
                    </div>
                  </div>
                  <div className="flex space-x-2 text-xs items-center ">
                    <div className="text-red-600  font-semibold">
                      {item?.prevValue}
                    </div>
                    <FontAwesomeIcon icon={faArrowRight} />
                    <div className="text-green-600 font-semibold ">
                      {item?.currentValue}
                    </div>
                  </div>
                  <div className="flex justify-end text-xs italic">
                    {moment(item?.updateAt).format("DD-MM-YYYY hh:mm a")}
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(SingleBookingDetail);

export const SingleBookingDetailItem = ({ label, value, iconname }) => {
  const { singleBookingDetailLoading } = useSelector((state) => state.booking);
  return (
    <>
      <div className="flex space-x-2 items-center">
        <FontAwesomeIcon icon={iconname} className="text-gray-400 w-5" />
        <div className="text-sm font-semibold text-gray-700">{label} </div>
        {singleBookingDetailLoading ? (
          <>
            <Skeleton animation="wave" width={200} />
          </>
        ) : (
          <div className="text-sm">{value}</div>
        )}
      </div>
    </>
  );
};
